import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server'
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import './Chat.css';
import ConversationInfo from '../../components/Chat/ConversationInfo/ConversationInfo';
import ChatMsgs from '../../components/Chat/ChatMsgs/ChatMsgs';
import AgentInfo from '../../components/Chat/AgentInfo/AgentInfo';
import ChatContacts from '../../components/Chat/ChatContacts/ChatContacts';
import AgentWindow from '../../components/Chat/AgentWindow/AgentWindow';
import Modal from '../../components/UI/Modal/Modal';
import CompanySettings from '../../components/Chat/CompanySettings/CompanySettings'
import MultipleMsgSending from '../../components/Chat/MultipleMsgSending/MultipleMsgSending'
import ChangeLogs from '../../components/UI/ChangeLog/ChangeLogs';
// import ChatProperties from '../../components/Chat/ChatProperties/ChatProperties';
import TextInput from '../../components/Chat/TextInput/TextInput';
import Logo from '../../components/Chat/Logo/Logo';
// import Categoryselect from '../../components/Chat/CategorySelect/CategorySelect';
import ChatSettings from '../../components/Chat/ChatSettings/ChatSettings';
// import socketIOClient from 'socket.io-client';//old socket
import { io } from "socket.io-client";
import * as allCallStatus from '../../enums/allCallStatus'
// import serverUrl from '../../serverUrl'
import Notification from 'react-web-notification';
import notificationSoundmp3 from '../../assets/notificationSound/sound.mp3'
import notificationSoundogg from '../../assets/notificationSound/sound.ogg'
// import { isMobile } from 'react-device-detect';
// import Emoji from '../../components/UI/Emoji/Emoji'
import { Emoji } from 'emoji-mart';
// import { parseString } from 'xml2js'
import { withTranslation } from "react-i18next";
// import { phonePattern } from '../../util/constants'

//notifications imports
import notificationImage from '../../assets/logo/notificationImage.jpg'
import whatsapp from '../../assets/whatsapp.png';
import sms from '../../assets/sms.png';
import messenger from '../../assets/messenger.png';
import forwardIcon from '../../assets/forwardIcon.png';
import mail from '../../assets/mail.png'
import instagram from '../../assets/instagram.png'
import companyIcon from '../../assets/home.png'
import IncomingCall from '../../assets/ringTypes/IncomingCall.png'
import * as agentWindowReq from '../../axios/requests/agentWindowReq'
import * as settingsReq from '../../axios/requests/settingsReq'
import * as tempMsgReq from '../../axios/requests/tempMsgReq'
import * as dialerReq from '../../axios/requests/dialerReq'
import * as loginRequests from '../../axios/requests/loginReq'
import * as facebookReq from '../../axios/requests/facebookReq'
import * as groupsReq from '../../axios/requests/groupsReq'
import * as extensionsReq from "../../axios/requests/extensionsReq"
import * as msgReq from '../../axios/requests/msgReq'
import * as crmReq from '../../axios/requests/crmReq'
import * as changeLogReq from '../../axios/requests/changeLogReq'
import * as userReq from '../../axios/requests/userReq'
import * as googleReq from '../../axios/requests/googleReq'
import * as filesReq from '../../axios/requests/filesReq'
import * as callbacksReq from '../../axios/requests/callBackReq'
import { deleteUnnecessaryPhoneChars, getNumberWithIsraelAreaCode, isPbxSupportActionType, withRouter } from '../../util/functions'
import * as chatReq from '../../axios/requests/chatReq'
import * as callReq from '../../axios/requests/callReq'
import axios from 'axios';
import * as settings from '../../settings'
import AlertContext from '../../context/AlertModelContext/AlertModalContext'
// import { Alert } from 'react-bootstrap';
import OpenContactModal from '../../components/Chat/ContactList/OpenContactModal';
import FileManager from '../../components/Chat/FileManager/FileManager';
import { deleteContactList } from '../../axios/requests/contactListReq';
import { fetchCallerId } from '../../axios/requests/callerIdReq';
import { searchBaseRecordByPhone } from '../../axios/requests/baseRecordReq';
import AdditionCallDetailsModal from '../../components/UI/AdditionCallDetailsModal/AdditionCallDetailsModal';
import CrmModal from '../../components/Chat/Crm/CrmModal';
import { Route, Routes, useParams, useLocation, Outlet } from "react-router-dom";
import i18next from "i18next";
// import ConfirmationModal from '../../components/UI/ConfirmationModal/ConfirmationModal ';


const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV
//
const checkAgentWindowStatusInterval = 60000
const incBreakSecInterval = 5000
const isCallStillLiveInterval = settings.CHECK_ACTIVE_CALLS_INTERVAL_MS || 60000
const refreshMediaTokenInSec = settings.REFRESH_MEDIA_TOKEN_IN_SEC || 60
const fetchAgentsIntervalSec = settings.FETCH_AGENTS_INTERVAL_SEC || 300

//Supported upload file types
const sendMediaSupportedTypes = settings.sendMediaSupportedTypes

//jump items every page
const jumpItemsInPage = settings.LIMIT_ITEMS_PER_PAGE || 50
const delayNow = ms => new Promise(resolve => setTimeout(resolve, ms))
const delayTimeInMlSec = 200
class Chat extends Component {
    static contextType = AlertContext
    handledCallIds = new Set();
    surveySentCallIds = new Set();

    fetchAndSetContactName = (call) => {
        if (call.crmId) return;
        searchBaseRecordByPhone(call.telephone).then(record => {
            const contactName = record?.fullName;
            if (contactName && this.props.nowCall?.callId === call.callId) {
                this.props.updateNowCall({ contactName });
            }
        }).catch(e => console.error('fetchAndSetContactName error', e));
    }

    state = {
        openOnInquirieTypeStateInitedFromRedux: false,
        logOutClicked: false,
        outSideLogoutTrigger: false,
        msgTextBox: '',
        msgTextBoxDisplay: '',
        searchTextBox: '',
        NewConvNameTextBox: '',//Name/Phone Number to send new msg
        NewConvSelectedChannel: 'company',//new conv selected channel
        NewSelectedChannelObj: { pageName: 'Select page', pageId: 0, instagramId: 0 },
        settingsSelected: 4, //1-All Chats,2-ChatWindow,3-setting window
        phoneWindowToShow: 1, //1-contacts window,2-chat with the contact,3-settings,4-Chat actions
        chatTypeSelected: 2,
        actionIdSelected: 1,
        socket: null,
        showSettingsModal: false,
        showContactListModal: false,
        contactListMode: 'add',
        whereTypped: 'CONTACT',
        // contactIdToDelete: null,
        // showConfirmationModal: false,
        showMultipleMsgSending: false,
        inputOpenFileRef: React.createRef(), //Ref to logo file select
        inputOpenFileKey: Math.random().toString(36),
        sendFileOpenFileRef: React.createRef(),
        sendFileOpenFileKey: Math.random().toString(36),
        isFileToSendSelected: false,
        fileToSend: null,
        callSelected: {
            _id: null,
            telephone: null,
            callObj: null
        },
        dialItemSelected: {
            _id: null,
            telephone: null,
            startTime: null,
            dialListObj: null
        },
        nowCallFromDiallist: {
            _id: null,
            telephone: null,
            status: null
        },
        isDialerOpen: false,
        isNewChatOpen: false,
        NotificationSystem: {//notification system
            ignore: true,
            title: '',
            timeout: 10000,

        },
        dialerTimeOutTime: 500,
        dialerIntervalObj: null,
        boreCount: 0,
        selectedChatCrmContact: null,
        selectedDialerCrmContact: null,
        selectedDialListCrmContact: null,
        selectedMsgTypesFilter: [],
        groupFilterSelected: undefined,
        mailSubject: '',
        mailTo: '',
        mailCc: '',
        mailBcc: '',
        agentBreakTimer: undefined,
        dialerConnectionAttemps: 1,
        selectMultipleBtnClicked: false,
        selectedMultipleChats: [],
        selectedMultipleDialList: [],
        selectedMultipleDialer: [],
        selectedChatsPage: 0,
        selectedCallsPage: 0,
        selectedDialListPage: 0,
        selectedContactPage: 0,
        callBack: {
            everySecToCheck: 0,
            callBackInterval: undefined
        },
        isCallStillLiveIntervalObj: undefined,
        facebook_userID: undefined,
        modal: {
            show: false,
            modalTitle: '',
            modalBody: '',
            btnList: [],
            onHide: undefined
        },
        tag: undefined,
        lastChannelId: undefined,
        reconnectAttempts: 0,
        showFileManager: false,
        refreshMediaTokenIntervalId: undefined,
        fileCategoryLimit: undefined,
        additionCallDetailsModalObj: {
            show: null,
            detailsType: null,
            telephone: null,
            onSave: (reason, note) => { }
        },
        isCallScheduledToDisconnect: false,
        applicationLanguage: i18next.language

    }

    componentWillUnmount() {
        this.state.callBack?.callBackInterval && clearInterval(this.state.callBack.callBackInterval)
        this.state.checkAgentWindowStateInterval && clearInterval(this.state.checkAgentWindowStateInterval)
        this.state.isCallStillLiveIntervalObj && clearInterval(this.state.isCallStillLiveIntervalObj)
        this.state.agentBreakTimer && clearInterval(this.state.agentBreakTimer)
        this.state.dialerIntervalObj && clearInterval(this.state.dialerIntervalObj)
        this.state.refreshMediaTokenIntervalId && clearInterval(this.state.refreshMediaTokenIntervalId)
    }

    componentDidMount() {

        setTimeout(this.checkAgentWindowStatus, 0)
        const checkAgentWindowTemp = setInterval(this.checkAgentWindowStatus, checkAgentWindowStatusInterval)
        this.refreshMediaToken()
        const refreshMediaTokenIntervalId = setInterval(this.refreshMediaToken, refreshMediaTokenInSec * 1000)
        this.setState({ checkAgentWindowStateInterval: checkAgentWindowTemp, refreshMediaTokenIntervalId })
        this.fetchCompanyExt()
        this.props.onLoadFetchChats();//{ channelFilter: this.props.supportedMsgTypes }
        this.props.fetchContacts(undefined, jumpItemsInPage, this.state.selectedContactPage)
        this.props.initCategoryMsgUnSeenStatus();
        this.props.fetchSettings();
        this.props.fetchCalls(undefined, jumpItemsInPage, this.state.selectedCallsPage);
        this.props.fetchDialList(undefined, jumpItemsInPage, this.state.selectedDialListPage);
        this.props.fetchAgentTempMsg();
        this.props.fetchAgents();
        setInterval(() => this.props.fetchAgents(), fetchAgentsIntervalSec * 1000)
        this.props.fetchCompanyGroups();
        this.props.fetchFacebookLogin();
        this.props.fetchMyNotifications();

        // const nsocket = socketIOClient(serverUrl, {//old socket
        //     withCredentials: true
        // });
        const nsocket = io(serverUrl, {
            withCredentials: true,  // Allows cross-origin requests with cookies
            autoConnect: true,      // Ensures the client attempts to connect immediately
            reconnectionAttempts: Infinity,
            // reconnectionDelay: 5000,         // Start with a 5-second delay
            // reconnectionDelayMax: 15000,     // Allow up to 15 seconds between retries
            randomizationFactor: 0.5,         // Randomize the delay to stagger connections
            transports: ["websocket"] // Optional: Specifies transport (useful for specific cases)
        });

        //serverUrl
        // nsocket.on("disconnect", () => {//on connection lost old socket
        //     console.log('connection lost:logout!');
        //     if (this.state.logOutClicked) {
        //         this.clearChatStoreStates()
        //         // window.location.reload();
        //     }
        //     else if (this.state.outSideLogoutTrigger) {
        //         window.open("about:blank", "_self");
        //     }
        //     else {
        //         window.location.reload();
        //         // window.close();
        //     }
        //     // window.location.reload();
        // });
        nsocket.on("disconnect", () => {//on connection lost
            console.log('connection lost:logout!');
            if (this.state.logOutClicked) {
                // console.log('@@@@@@@@@@@@@@@@@disconnect1@@@@@@@@@@@@@@@@@')
                this.clearChatStoreStates()
                // window.location.reload();
            }
            else if (this.state.outSideLogoutTrigger) {
                // console.log('@@@@@@@@@@@@@@@@@disconnect2@@@@@@@@@@@@@@@@@')
                // window.open("about:blank", "_self");
                this.props.navigate("/disconnected");
            }
            else {
                // console.log(`@@@@@@@@@@@@@@@@@disconnect3@@@@@@@@@@@@@@@@@ reconnectAttempts=${this.state.reconnectAttempts}`)
                if (this.state.reconnectAttempts < settings.MAX_RECONNECT_ATTEMPTS) {
                    setTimeout(() => nsocket.connect(), settings.ON_DISCONNECT_TRY_RECONNECT_TIMEOUT || 5000)
                    this.setState((prevState) => ({ reconnectAttempts: prevState.reconnectAttempts + 1 }))
                }
                else {
                    window.location.reload();
                }
                //window.location.reload();
                // window.close();
            }
            // window.location.reload();
        });

        // nsocket.on('connect_error', () => {
        //     // console.log(`@@@@@@@@@@@@@@@@@connect_error@@@@@@@@@@@@@@@@@ reconnectAttempts=${this.state.reconnectAttempts}`)
        //     // alert('נותקת עקב יציבות רשת')

        //     if (this.state.reconnectAttempts < settings.MAX_RECONNECT_ATTEMPTS) {
        //         setTimeout(() => nsocket.connect(), settings.ON_DISCONNECT_TRY_RECONNECT_TIMEOUT || 5000)
        //         this.setState((prevState) => ({ reconnectAttempts: prevState.reconnectAttempts + 1 }))
        //     }
        //     else {
        //         window.location.reload();
        //     }
        //     // this.props.onLogout();
        //     // this.props.logoutCleanChats();
        //     // window.location.reload();
        // })

        nsocket.on("connect", () => {
            console.log('Connected!!!')
            this.setState({ reconnectAttempts: 0 })
            nsocket.emit('join', { agent: this.props.agentName, conv: this.props.agentName, companyId: this.props.companyId }, (res) => {
                if (res) {
                    let nowSelectedCategory = 'newInquiries'
                    if (this.state.chatTypeSelected === 1) nowSelectedCategory = 'newInquiries'
                    else if (this.state.chatTypeSelected === 2) nowSelectedCategory = 'inProgressInquiries'
                    else if (this.state.chatTypeSelected === 3) nowSelectedCategory = 'historicalInquiries'
                    else if (this.state.chatTypeSelected === 4) nowSelectedCategory = 'allAgentInquiries'
                    else if (this.state.chatTypeSelected === 5) nowSelectedCategory = 'allAgentHistoricalInquiries'
                    else if (this.state.chatTypeSelected === 6) nowSelectedCategory = 'allAgentInquiries'
                    if (res.isOk) {
                        nsocket.emit('join', { agent: this.props.agentName, category: nowSelectedCategory + this.props.companyId, companyId: this.props.companyId }, (error) => {
                            if (error) {
                                console.log(error)
                            }
                        })
                        nsocket.emit('join', { agent: this.props.agentName, extId: this.props.extId, companyId: this.props.companyId }, (error) => {
                            if (error) {
                                console.log(error)
                            }
                        })

                        if (this.props.chatSelectedSenderName && this.props.chatSelectedChannel) {
                            this.state.socket.emit('join', { agent: this.props.agentName, conv: this.props.chatSelectedSenderName + this.props.companyId + this.props.chatSelectedChannel, companyId: this.props.companyId }, (error) => {
                                if (error) {
                                    console.log(error)
                                }
                            })
                        }
                    }
                    else {
                        console.log('error to login msg=')
                        console.log(res.msg)
                    }
                }
            })
        })

        // nsocket.on('connect_error', () => {
        //     alert('נותקת עקב יציבות רשת')
        //     // localStorage.removeItem('token');
        //     // localStorage.removeItem('userId');
        //     this.props.onLogout();
        //     this.props.logoutCleanChats();
        //     window.location.reload();
        // })


        nsocket.on('deviceConnectedToPbx', (data) => {
            console.log('deviceConnectedToPbx data=' + JSON.stringify(data));
            let setPbxConnectedStatus = data.isPbxConnected ? 'connected' : 'notConnected'


            if (isPbxSupportActionType(this.props.pbxType, 'RECONNECT_PBX') && !data.isPbxConnected) {
                this.props.clearNowCall()
                if (this.state.dialerConnectionAttemps <= settings.MAX_PBX_RECONNECT_ATTEMPTS) {
                    setTimeout(this.handleOnDialerReConnectBtnClicked, settings.RECONNECT_TIME_OUT_SEC * 1000)
                    // this.handleOnDialerReConnectBtnClicked()
                    this.setState({ dialerConnectionAttemps: this.state.dialerConnectionAttemps + 1 })
                    setPbxConnectedStatus = 'connecting'
                }
            }
            else if (data.isPbxConnected) {
                isPbxSupportActionType(this.props.pbxType, 'CHECK_ACTIVE_CALLS') && callReq.isCallStillLive()
                // dialerReq.checkActiveCalls()
                this.setState({ dialerConnectionAttemps: 1 })
            }

            this.props.setPbxConnectedStatus(data.isPbxConnected, setPbxConnectedStatus)
            if (data.isPbxConnected) this.resetDialerInterval()
            else this.stopDialerInterval()
        });

        //Errors handlers
        nsocket.on('onError', (message) => {//onNotificationDelete
            this.context.showAlert(this.props.t('error'), this.props.t(message), 'sm')
        })
        //notifications handlers
        nsocket.on('onNotificationAdded', (notificationData) => {//onNotificationDelete
            console.log('onNotificationAdded')
            console.log(notificationData)
            this.props.addNewNotification(notificationData)
        })
        nsocket.on('onNotificationUpdate', (notificationData) => {
            console.log('onNotificationUpdate')
            console.log(notificationData)
            this.props.updateNotification(notificationData)
        })
        nsocket.on('onNotificationDelete', (notificationData) => {
            console.log('onNotificationDelete')
            console.log(notificationData)
            this.props.deleteNotification(notificationData._id)
        })

        nsocket.on('onHold', (data) => {
            console.log('onHold')
            this.props.callHoldEvent(data)
        })
        nsocket.on('onDeviceStatusChangeHandler', (data) => {
            console.log('onDeviceStatusChangeHandler')
            this.props.changeAgentWindowState({ acdState: data.state })
        })

        nsocket.on('logout', () => {
            console.log('logout');
            this.setState({ outSideLogoutTrigger: true })
            // this.setState({ logOutClicked: true })
            // setTimeout(this.handleOnlogoutClicked, 0)
            // this.handleOnlogoutClicked()
            // this.props.onLogout()
            // window.location.reload();
        });
        nsocket.on('remoteOpenNewConv', (newConv) => {
            console.log('remoteOpenNewConv');
            console.log(newConv)
            //NewConvNameTextBox,NewConvSelectedChannel,NewSelectedChannelObj={}
            this.setState({ NewConvNameTextBox: newConv.clientName, NewConvSelectedChannel: newConv.msgType, NewSelectedChannelObj: newConv.channelObj })
            setTimeout(this.handleOnNewConvClicked, 0)
        });
        nsocket.on('onFacebookLoginStatusChanged', (facebookLogin) => {
            console.log('onFacebookLoginStatusChanged');
            console.log(facebookLogin)
            const nowUnixTime = Date.now()
            if (facebookLogin.userToken_expiration_time || facebookLogin.userToken_expiration_time === 0) {
                if (facebookLogin.userToken_expiration_time * 1000 > nowUnixTime || facebookLogin.userToken_expiration_time === 0) {
                    this.props.fetchFacebookLoginSuccess(true)
                    this.props.fetchFacebookSubscribedPages()
                    setTimeout(() => this.fetchFacebookFeedPosts(), settings.fetchFacebookFeedPostAfterMiliSec)
                }
            }
            else {
                this.props.fetchFacebookLoginSuccess(false)
                this.setState({ facebook_userID: undefined })
            }
        });
        nsocket.on('deleteManyChatsRecived', (filters) => {
            console.log('deleteManyChatsRecived');
            // console.log(filters)
            this.props.deleteManyChats(filters)
        });
        nsocket.on('listOfOnlineAgents', (listOfOnlineAgents) => {
            console.log('listOfOnlineAgents');
            this.props.companyOnlineAgents(listOfOnlineAgents, 'listOfOnlineAgents')
        });
        nsocket.on('newAgentOnline', (newAgentOnline) => {
            console.log('newAgentOnline');
            console.log(newAgentOnline)

            this.props.companyOnlineAgents(newAgentOnline, 'newAgentOnline')
        });
        nsocket.on('updateAgentOnlineExt', (updatedOnlineAgentExt) => {
            console.log('updateAgentOnlineExt');
            console.log(updatedOnlineAgentExt)
            this.props.companyOnlineAgents(updatedOnlineAgentExt, 'updateAgentOnlineExt')
        });
        nsocket.on('agentLeft', (agentLeft) => {
            console.log('agentLeft');
            this.props.companyOnlineAgents(agentLeft, 'agentLeft')
        });
        nsocket.on('newMsgReceived', (message) => {
            console.log('newMsgReceived');
            if (this.state.selectedMsgTypesFilter?.length > 0 && !this.state.selectedMsgTypesFilter.includes(message.msg.msgType)) {
                return;
            }
            const min = 50; const max = 1000;
            const randomMilSecToSendNotify = Math.floor(Math.random() * (max - min + 1) + min)
            setTimeout(() => this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { notSeenCount: 0 }), randomMilSecToSendNotify);
            this.props.newMsgRecived(message);
        });
        nsocket.on('deleteMsgReceived', (obj) => {
            console.log('deleteMsgReceived');
            console.log(obj)
            this.props.deleteMsgRecived(obj.msg, obj.chat)

        });
        nsocket.on('callDetailsUpdateReceivedEvent', (call) => {
            console.log('callDetailsUpdateReceivedEvent');
            this.props.callDetailsUpdate(call);
        });
        nsocket.on('dialListDetailsUpdateReceivedEvent', (dialList) => {
            console.log('dialListDetailsUpdateReceivedEvent');
            this.props.dialListDetailsUpdate(dialList);
        });
        nsocket.on('updateMsgReceived', (data) => {
            console.log('updateMsgReceived1');
            // console.log(data)
            let message = data
            if (typeof message.msg !== 'object') {
                message = { msg: message }
            }
            console.log(message)

            // if (message.msg.clientName === this.props.chatSelectedSenderName && message.msg.msgType === this.props.chatSelectedChannel) {
            this.props.updateMsgRecived(message);
            // }
        });

        nsocket.on('onAgentChatSeenCountUpdate', (conversation) => {
            console.log('onAgentChatSeenCountUpdate');
            // console.log(conversation)
            const isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        })

        nsocket.on('onAgentMsgClicked', (conversation) => {
            console.log('onMsgClicked');
            //check group filter
            let isAgentOnConvGroups = false
            if (this.state.groupFilterSelected) {
                if (!this.checkIfAgentOnConvGroups(conversation, [this.state.groupFilterSelected])) {
                    isAgentOnConvGroups = false
                }
                else {
                    isAgentOnConvGroups = true
                }

            }
            else if (!this.state.groupFilterSelected) {
                isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            }
            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        })
        nsocket.on('onCrmUpdate', (conversation) => {
            console.log('onCrmUpdate');
            const isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        })


        nsocket.on('onSendMsg_updateChatReceived', (conversation) => {
            console.log('onSendMsg_updateChatReceived');
            console.log(conversation)
            let name = ''
            if (!conversation.chat.crmId) name = ''
            else name = conversation.chat.crmId.name

            const isAgentPartOfTheChat = conversation.chat.agentName.find(agentobj => agentobj.agent === this.props.agentName)

            if (isAgentPartOfTheChat &&
                !conversation.chat.isPublic &&
                !conversation.chat.completed &&
                (conversation.chat.lastAction.agent !== this.props.agentName) &&
                (conversation.chat.clientName !== this.props.chatSelectedSenderName || conversation.chat.msgType !== this.props.chatSelectedChannel)
            ) {//if agent part of the conv
                // console.log('notify on new msg part of the chat')
                this.showNotification(conversation.chat.msgType, conversation.chat.clientName.replace('+972', 0), conversation.chat.latestMsg, conversation.chat.latestMsgTime, name);
            }

            if (//from public chat to some agent inquiries
                this.props.chatSelectedSenderName &&
                this.props.chatSelectedChannel &&
                this.props.chatSelectedSenderName.replace(new RegExp("05", "g"), '+9725').toLowerCase() === conversation.chat.clientName &&
                this.props.chatSelectedChannel === conversation.chat.msgType &&
                conversation.chat.agentName.length > 0 &&
                this.state.chatTypeSelected === 1 &&
                conversation.chat.oldChatIsPublic === true &&
                conversation.chat.isPublic === false &&
                !isAgentPartOfTheChat
            ) {
                this.state.socket.emit('join', { agent: this.props.agentName, conv: 'ChatNotSelected' + this.props.companyId + this.state.NewConvSelectedChannel, companyId: this.props.companyId }, (error) => { if (error) { console.log(error) } })
                this.props.clearMsgs();
            }

            //check if gotten chat is accepted by channels filter

            if (this.state.selectedMsgTypesFilter?.length > 0 && !this.state.selectedMsgTypesFilter.find((msgType) => msgType === conversation.chat.msgType)) return

            //check group filter
            let isAgentOnConvGroups = false
            if (this.state.groupFilterSelected) {
                if (!this.checkIfAgentOnConvGroups(conversation, [this.state.groupFilterSelected])) {
                    isAgentOnConvGroups = false
                }
                else {
                    isAgentOnConvGroups = true
                }

            }
            else if (!this.state.groupFilterSelected) {
                isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            }
            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        })
        nsocket.on('onMsgRecived_updateChatReceived', (conversation) => {
            console.log('onMsgRecived_updateChatReceived');
            console.log(conversation)
            let name = ''
            if (!conversation.chat.crmId) name = ''
            else name = conversation.chat.crmId.name

            const isAgentPartOfTheChat = conversation.chat.agentName.find(agentobj => agentobj.agent === this.props.agentName)

            if (isAgentPartOfTheChat &&
                !conversation.chat.isPublic &&
                !conversation.chat.completed &&
                (conversation.chat.clientName !== this.props.chatSelectedSenderName || conversation.chat.msgType !== this.props.chatSelectedChannel)
            ) {//if agent part of the conv
                // console.log('notify on new msg part of the chat')
                this.showNotification(conversation.chat.msgType, conversation.chat.clientName.replace('+972', 0), conversation.chat.latestMsg, conversation.chat.latestMsgTime, name);
            }

            //check if gotten chat is accepted by channels filter
            if (this.state.selectedMsgTypesFilter?.length > 0 && !this.state.selectedMsgTypesFilter.find((msgType) => msgType === conversation.chat.msgType)) return

            //check group filter
            let isAgentOnConvGroups = false
            if (this.state.groupFilterSelected) {
                if (!this.checkIfAgentOnConvGroups(conversation, [this.state.groupFilterSelected])) {
                    isAgentOnConvGroups = false
                }
                else {
                    isAgentOnConvGroups = true
                }

            }
            else if (!this.state.groupFilterSelected) {
                isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            }
            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        })

        nsocket.on('notifyAgentAddedToTheChat', (conv) => {
            console.log('notifyAgentAddedToTheChat')
            console.log(conv.chat)
            let name = ''
            if (!conv.chat.crmId) name = ''
            else name = conv.chat.crmId.name

            const dateTime = new Date()
            this.showNotification(conv.chat.msgType, conv.chat.clientName.replace('+972', 0), this.props.t('Chat forwarding'), dateTime, name);
        })

        nsocket.on('updateChatReceived', (conversation) => {
            console.log('updateChatReceived');
            console.log(conversation)
            // let name = ''
            // if (!conversation.chat.crmId) name = ''
            // else name = conversation.chat.crmId.name

            const isAgentPartOfTheChat = conversation.chat.agentName.find(agentobj => agentobj.agent === this.props.agentName)


            // if (isAgentPartOfTheChat &&
            //     !conversation.chat.isPublic &&
            //     ((!conversation.chat.completed && conversation.chat.oldChatIsCompleted) || conversation.chat.oldChatIsPublic === true) &&
            //     (conversation.chat.clientName !== this.props.chatSelectedSenderName || conversation.chat.msgType !== this.props.chatSelectedChannel)
            // ) {//if agent part of the conv
            //     // console.log('notify on new msg part of the chat')
            //     const dateTime = new Date()
            //     this.showNotification(conversation.chat.msgType, conversation.chat.clientName.replace('+972', 0), 'הפניית שיחה', dateTime, name);
            // }


            //@@@@@@@@@@@@@@@@@@@@@@@@ when clear MSGS: @@@@@@@@@@@@@@@@@@@@@@@@

            if (//from public chat to some agent inquiries
                this.props.chatSelectedSenderName &&
                this.props.chatSelectedChannel &&
                this.props.chatSelectedSenderName.replace(new RegExp("05", "g"), '+9725').toLowerCase() === conversation.chat.clientName &&
                this.props.chatSelectedChannel === conversation.chat.msgType &&
                conversation.chat.agentName.length > 0 &&
                this.state.chatTypeSelected === 1 &&
                conversation.chat.oldChatIsPublic === true &&
                conversation.chat.isPublic === false &&
                !isAgentPartOfTheChat
            ) {
                this.state.socket.emit('join', { agent: this.props.agentName, conv: 'ChatNotSelected' + this.props.companyId + this.state.NewConvSelectedChannel, companyId: this.props.companyId }, (error) => { if (error) { console.log(error) } })
                this.props.clearMsgs();
            }

            if (//when close chat all agents get out
                this.props.chatSelectedSenderName &&
                this.props.chatSelectedChannel &&
                this.props.chatSelectedSenderName.replace(new RegExp("05", "g"), '+9725').toLowerCase() === conversation.chat.clientName &&
                this.props.chatSelectedChannel === conversation.chat.msgType &&
                conversation.chat.completed === true &&
                conversation.chat.oldChatIsCompleted === false &&
                this.state.chatTypeSelected !== 6 &&
                this.state.chatTypeSelected !== 3 &&
                this.state.chatTypeSelected !== 5

            ) {
                this.state.socket.emit('join', { agent: this.props.agentName, conv: 'ChatNotSelected' + this.props.companyId + this.state.NewConvSelectedChannel, companyId: this.props.companyId }, (error) => { if (error) { console.log(error) } })
                this.props.clearMsgs();
            }

            //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

            //check if gotten chat is accepted by channels filter
            if (this.state.selectedMsgTypesFilter?.length > 0 && !this.state.selectedMsgTypesFilter.find((msgType) => msgType === conversation.chat.msgType)) return

            //check group filter
            let isAgentOnConvGroups = false
            if (this.state.groupFilterSelected) {
                if (!this.checkIfAgentOnConvGroups(conversation, [this.state.groupFilterSelected])) {
                    isAgentOnConvGroups = false
                }
                else {
                    isAgentOnConvGroups = true
                }

            }
            else if (!this.state.groupFilterSelected) {
                isAgentOnConvGroups = this.checkIfAgentOnConvGroups(conversation, this.props.agent_groupList)
            }


            this.props.updateConversation(conversation, this.state.chatTypeSelected, this.props.agentName, isAgentOnConvGroups);
        });
        nsocket.on('newChatReceived', (conversation) => {
            console.log('newChatReceived');
            if (this.state.selectedMsgTypesFilter?.length > 0 && !this.state.selectedMsgTypesFilter.includes(conversation.chat.msgType)) {
                return;
            }
            if (this.state.chatTypeSelected === 1 && conversation.chat.isPublic === true && conversation.chat.completed === false) {
                this.props.newConversation(conversation);
            }
            else if (this.state.chatTypeSelected === 2 && conversation.chat.isPublic === false && conversation.chat.completed === false && conversation.chat.agentName.find(agent => agent.agent === this.props.agentName)) {
                this.props.newConversation(conversation);
            }
            else if (this.state.chatTypeSelected === 4) {
                console.log('here ok')
                this.props.newConversation(conversation)
            }
            else if (this.state.chatTypeSelected === 6) {
                console.log('here ok')
                this.props.newConversation(conversation)
            }
            else console.log('not public chat selected')

        });
        nsocket.on('deleteChatReceived', (conversation) => {
            console.log('deleteChatReceived');
            if (this.props.chatSelectedSenderName !== null && this.props.chatSelectedChannel !== null && this.props.chatSelectedSenderName.replace(new RegExp("05", "g"), '+9725').toLowerCase() === conversation.chat.clientName && this.props.chatSelectedChannel === conversation.chat.msgType) {
                this.state.socket.emit('join', { agent: this.props.agentName, conv: 'ChatNotSelected' + this.props.companyId + this.state.NewConvSelectedChannel, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                this.props.clearMsgs();
            }
            this.props.deleteChatRecived(conversation, this.state.chatTypeSelected);
        });
        nsocket.on('categoryMsgUnSeenStatusUpdateReceived', (categoryUnSeenStatusUpdateObj) => {
            console.log('categoryMsgUnSeenStatusUpdateReceived')
            console.log(categoryUnSeenStatusUpdateObj)
            this.props.updateCategoryMsgUnSeenStatus(categoryUnSeenStatusUpdateObj)
            //this.props.initCategoryMsgUnSeenStatus();
        });

        nsocket.on('initCategoryMsgUnSeenStatusReceived', () => {
            console.log('initCategoryMsgUnSeenStatusReceived')
            this.props.initCategoryMsgUnSeenStatus();
        });



        // const intervalTime = 60000 //60000 miliseconds(1 minute)
        // let count = 0;
        // const totalRuns = settings.TOTAL_RUNS;

        // const intervalId = setInterval(boundCheckActiveCallsInterval, intervalTime);
        // const boundCheckActiveCallsInterval = () => {
        //     count++;
        //     if (count >= totalRuns) {
        //         clearInterval(intervalId);
        //     }
        // }




        nsocket.on('CallReceivedEvent', async (nowCall) => {
            console.log('CallReceivedEvent');
            console.log(nowCall);
            let name = ''
            if (!nowCall.crmId) {
                name = ''
            }
            else {
                name = nowCall.crmId.name
                if (this.props.settings.calls.popUpCrmWindow.incomingCall_enable) {//&& !this.props.settings.calls.popUpCrmWindow.incomingCall_onAnswer
                    if (!this.props.nowCall || (this.props.nowCall && this.props.nowCall.callId !== nowCall.callId)) {
                        // window.open(nowCall.crmId.siteUrl, "_blank")
                        this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, nowCall?.crmId, this.props.urlOnNewContact, nowCall.telephone, false)
                    }
                }
            }
            if (nowCall.ringType === 1) this.showNotification('call', nowCall.telephone, this.props.t('Incoming call'), nowCall.startTime, name)

            if (this.props.nowCall && nowCall && this.props.nowCall.callId !== nowCall.callId) {
                isPbxSupportActionType(this.props.pbxType, 'CHECK_ACTIVE_CALLS') && setTimeout(() => this.onNewCallCheckConflict(this.props.nowCall, nowCall), 0);
            }
            else {
                if (this.props.enableGetCallerId) {
                    nowCall.callerId = await fetchCallerId(nowCall.telephone);
                }
                // if (this.props.settings.calls.alwaysOpenCrmPopup && this.props.settings.calls.popUpCrmWindow.incomingCall_enable) {
                //     this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, nowCall.crmId || null, this.props.urlOnNewContact, nowCall.telephone, false);
                // }
                this.props.CallReceivedEvent(nowCall);
                this.fetchAndSetContactName(nowCall);
                if (this.state.isCallStillLiveIntervalObj) {
                    clearInterval(this.state.isCallStillLiveIntervalObj)
                }
                if (isPbxSupportActionType(this.props.pbxType, 'CHECK_ACTIVE_CALLS')) {
                    const isCallStillLiveIntervalObj = setInterval(() => this.isCallStillLive(nowCall.callId), isCallStillLiveInterval)
                    // const isCallStillLiveIntervalObj = setInterval(() => { this.isCallStillLive(nowCall.callId); boundCheckActiveCallsInterval() }, isCallStillLiveInterval)
                    this.setState({ isCallStillLiveIntervalObj: isCallStillLiveIntervalObj })
                }
            }
            this.setState({ isCallScheduledToDisconnect: false })
        });
        nsocket.on('CallAnsweredEvent', async (nowCall) => {
            console.log('CallAnsweredEvent');
            console.log(nowCall);
            if (this.handledCallIds.has(nowCall.callId)) {
                console.log(`CallAnsweredEvent for callId=${nowCall.callId} already handled, skipping.`);
                return;
            }

            this.handledCallIds.add(nowCall.callId);
            if (this.props.settings.dialList.autoCloseDialistOnEndCall) {
                if (nowCall.telephone === this.state.nowCallFromDiallist.telephone) {
                    this.props.dialListDelete({
                        all: false,
                        data: [{
                            _id: this.state.nowCallFromDiallist._id
                        }]
                    });
                };
                this.setState({
                    nowCallFromDiallist: {
                        _id: null,
                        telephone: null,
                        status: null,
                        obj: null
                    }
                });
            }
            if (!nowCall.crmId) {/*Do nothing*/ }
            else {//open source in new tab
                if (this.props.settings.calls.popUpCrmWindow.incomingCall_onAnswer && !this.props.settings.calls.alwaysOpenCrmPopup) {//this.props.settings.calls.popUpCrmWindow.incomingCall_enable &&
                    if (!this.props.nowCall || (this.props.nowCall && !this.props.nowCall.ansTime)) {
                        // window.open(nowCall.crmId.siteUrl, "_blank")
                        this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, nowCall?.crmId, this.props.urlOnNewContact, nowCall.telephone, false)
                    }
                }
            }
            if (this.props.enableGetCallerId) {
                nowCall.callerId = await fetchCallerId(nowCall.telephone);
            }
            if (this.props.settings.calls.alwaysOpenCrmPopup && !this.props.settings.calls.passRelatedCallId && this.props.settings.calls.popUpCrmWindow.incomingCall_onAnswer) {
                this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, nowCall.crmId || null, this.props.urlOnNewContact, nowCall.telephone, false);
            }
            if (this.props.settings.calls.alwaysOpenCrmPopup && this.props.settings.calls.passRelatedCallId && this.props.settings.calls.popUpCrmWindow.incomingCall_onAnswer) {
                this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, nowCall.crmId || null, this.props.urlOnNewContact, nowCall.telephone, false, nowCall?.relatedCallId);
            }
            this.props.CallAnsweredEvent(nowCall);
            this.fetchAndSetContactName(nowCall);
            this.setState({ isCallScheduledToDisconnect: false })
        });
        nsocket.on('CallReleasedEvent', (nowCall) => {
           
            console.log('CallReleasedEvent');
            console.log(nowCall)
            console.log('nowCall.telephone=' + nowCall.telephone)
            console.log('this.state.nowCallFromDiallist.telephone=' + this.state.nowCallFromDiallist.telephone)
            if (nowCall.callId) {
                this.handledCallIds.delete(nowCall.callId);
                console.log(`Cleared handledCallIds for callId=${nowCall.callId}`);
            }
            if (nowCall.telephone === this.state.nowCallFromDiallist.telephone) {
                this.props.dialListUpdate({
                    all: false,
                    data: [
                        {
                            _id: this.state.nowCallFromDiallist._id,
                            status: this.state.nowCallFromDiallist.status === 'bore' ? 'bore' : 'notactive'
                        }
                    ]
                });//Change to notactive   
            };
            if (this.state.dialerIntervalObj) clearInterval(this.state.dialerIntervalObj)
            if (this.props.settings.dialList.autoCloseDialistOnEndCall) {
                this.setState({
                    nowCallFromDiallist: {
                        _id: null,
                        telephone: null,
                        status: null,
                        obj: null
                    }
                    // ,dialerIntervalObj: this.props.isDialerActive ? setInterval(this.runOnDialList, this.state.dialerTimeOutTime) : undefined
                });
            }
            this.resetDialerInterval()
            // Send call survey if enabled and this agent was on the call
            const israeliPrefixes = ['02', '03', '04', '08', '09', '073', '074', '076', '077', '078', '079'];
            const hasIsraeliPrefix = israeliPrefixes.some(prefix => nowCall.telephone?.startsWith(prefix));
            const digitCount = nowCall.telephone?.replace(/\D/g, '').length || 0;
            const isShortIsraeliNumber = hasIsraeliPrefix && digitCount < 7;

            if (this.props.settings?.calls?.callSurvey?.enabled &&
                this.props.nowCall?.telephone === nowCall.telephone &&
                nowCall.callId &&
                !this.surveySentCallIds.has(nowCall.callId) &&
                !isShortIsraeliNumber &&
                nowCall.durationSec > 0) {
                callReq.sendCallSurvey(this.props.extId, nowCall.telephone, this.props.agentName);
                this.surveySentCallIds.add(nowCall.callId);
                console.log(`Survey sent for callId=${nowCall.callId}`);
            }
            if (!nowCall.crmId && this.props.nowCall?.contactName) {
                nowCall.contactName = this.props.nowCall.contactName;
            }
            this.props.CallReleasedEvent(nowCall);
            if (!nowCall.crmId && !nowCall.contactName) {
                searchBaseRecordByPhone(nowCall.telephone).then(record => {
                    if (record?.fullName && nowCall._id) {
                        this.props.callDetailsUpdate({ _id: nowCall._id, contactName: record.fullName });
                    }
                }).catch(e => console.error('CallReleasedEvent contact lookup error', e));
            }
            this.setState({ isCallScheduledToDisconnect: false })
        });
        nsocket.on('callEnded', (nowCall) => {
            console.log('callEnded');
            // console.log(nowCall)
            if (nowCall.telephone === this.state.nowCallFromDiallist.telephone) {
                this.props.dialListUpdate({
                    all: false,
                    data: [
                        {
                            _id: this.state.nowCallFromDiallist._id,
                            status: this.state.nowCallFromDiallist.status === 'bore' ? 'bore' : 'notactive'
                        }
                    ]
                });//Change to notactive   
            };
            if (this.state.dialerIntervalObj) clearInterval(this.state.dialerIntervalObj)
            if (this.props.settings.dialList.autoCloseDialistOnEndCall) {
                this.setState({
                    nowCallFromDiallist: {
                        _id: null,
                        telephone: null,
                        status: null,
                        obj: null
                    }
                    // ,dialerIntervalObj: this.props.isDialerActive ? setInterval(this.runOnDialList, this.state.dialerTimeOutTime) : undefined
                });
            }
            this.resetDialerInterval()
            this.props.CallReleasedEvent(nowCall);
            this.setState({ isCallScheduledToDisconnect: false })
        });
        nsocket.on('dialListAdded', (dialItem) => {
            console.log('dialListAdded');
            this.props.dialListAdded(dialItem)
        });
        nsocket.on('dialListUpdated', (dialList) => {
            console.log('dialListUpdate');
            this.props.dialListUpdated(dialList)
        });
        nsocket.on('dialListDeleted', (dialList) => {
            console.log('dialListDeleted');
            this.props.dialListDeleted(dialList)
        });
        nsocket.on('dialListAutoDeleted', (dialList) => {
            console.log('dialListAutoDeleted:', dialList);
            this.props.dialListAutoDeleted(dialList.data);
        });
        nsocket.on('dialListPostponedToOtherAgent', (dialList) => {
            console.log('dialListPostponedToOtherAgent:', dialList);
            this.props.dialListPostponedToOtherAgent(dialList);
        });
        nsocket.on('callDeleted', (calls) => {
            console.log('callDeleted');
            this.props.callDeleted(calls)
        });
        //@@@@@@@@@@AgentWindow@@@@@@@@@@
        nsocket.on('acdStateChanged', (data) => {
            console.log('acdStateChanged');
            this.props.changeAgentWindowState({ acdState: data.newState })
        });
        nsocket.on('startBreak', (data) => {
            console.log('startBreak');
            this.props.changeAgentWindowState(data.breakData)
            if (this.props.settings?.dialList?.enableChangeGetCallBacksStateOnBreak) {
                this.props.changeAgentDialerState({ isDialerActive: false })
            }
        });
        nsocket.on('stopBreak', (data) => {
            console.log('stopBreak');
            this.props.changeAgentWindowState({ breakName: null, breakStartTime: null, breakDurationSec: null })
            if (this.props.settings?.dialList?.enableChangeGetCallBacksStateOnBreak) {
                this.props.changeAgentDialerState({ isDialerActive: true })
            }
        });
        nsocket.on('changeAgentDialerState', (data) => {
            console.log('changeAgentDialerState')
            this.props.changeAgentDialerState(data)
        });

        //@@@@@@@@@@@@@@@@@@@@Groups events@@@@@@@@@@@@@@@@@@@@
        nsocket.on('onNewGroup', (data) => {
            console.log('onNewGroup')
            this.props.onGroupsActions(data, 'ADD_GROUP')
        });
        nsocket.on('onRemoveGroup', (data) => {
            console.log('onRemoveGroup')
            this.props.onGroupsActions(data, 'REMOVE_GROUP')
        });
        nsocket.on('onAddAgentToGroup', (data) => {
            console.log('onAddAgentToGroup')
            // console.log(data)
            if (this.props.agentName === data.agentName) {
                this.setState({ groupFilterSelected: undefined })
                if (this.state.chatTypeSelected === 7) {
                    setTimeout(() => this.activeFetchChats(this.state.chatTypeSelected, this.state.searchTextBox, this.state.selectedMsgTypesFilter, undefined), 0)
                }
            }
            this.props.onGroupsActions(data, 'ADD_AGENT_TO_GROUP')
        });
        nsocket.on('onDeleteAgentFromGroup', (data) => {
            console.log('onDeleteAgentFromGroup')
            if (this.props.agentName === data.agentName) {
                this.setState({ groupFilterSelected: undefined })
                if (this.state.chatTypeSelected === 7) {
                    setTimeout(() => this.activeFetchChats(this.state.chatTypeSelected, this.state.searchTextBox, this.state.selectedMsgTypesFilter, undefined), 0)
                }
            }
            // console.log(data)
            this.props.onGroupsActions(data, 'REMOVE_AGENT_FROM_GROUP')
        });

        //CONTACTS
        nsocket.on('onNewContact', (contact) => {
            console.log('onNewContact')
            console.log(contact)
            this.props.insertContact(contact)
            this.props.insertChatContact(contact)
            this.props.insertCallContact(contact)
            this.props.insertDialListContact(contact)
        });
        nsocket.on('onUpdateContact', (contact) => {
            console.log('onUpdateContact')
            console.log(contact)
            this.props.updateContact(contact)
            this.props.updateChatContact(contact)
            this.props.updateCallContact(contact)
            this.props.updateDialListContact(contact)
        });
        nsocket.on('onDeleteContact', (contact) => {
            console.log('onDeleteContact')
            console.log(contact)
            this.props.deleteContact(contact)
            this.props.deleteChatContact(contact)
            this.props.deleteCallContact(contact)
            this.props.deleteDialListContact(contact)
        });

        // console.log('isDialerActive=' + this.props.isDialerActive)
        if (!this.props.isDialerActive) {

            this.stopDialerInterval()
        }
        else {
            // if (this.state.dialerIntervalObj) clearInterval(this.state.dialerIntervalObj)
            this.resetDialerInterval()
        }


        this.popUpLastChangeLogs()

        if (this.props.queryParams.clientName && this.props.queryParams.msgType && this.props.dashboardSection === 'conv') {
            this.openNewApiConvByMsgTypeAndClientName(this.props.queryParams.msgType, this.props.queryParams.clientName, this.props.queryParams.msgId, this.props.queryParams.startTime, this.props.queryParams.finishTime)
        }



        if (this.props.tokenExpiresInMin) { //Logout when token expired
            setTimeout(() => this.handleOnlogoutClicked(), this.props.tokenExpiresInMin - 5000)//minus 5 sec
        }


        // this.setState({ socket: nsocket, dialerIntervalObj: this.props.isDialerActive ? setInterval(this.runOnDialList, this.state.dialerTimeOutTime) : undefined });
        this.setState({ socket: nsocket });
        // this.setState({ showCrmModal: this.props.crmPath.crm === 'crm' })


    }



    clearChatStoreStates = () => {
        this.props.onLogout()
        this.props.logoutCleanChats()
        this.props.clearDialerState()
        this.props.clearSettingsState()
        this.props.clearNotificationsState()
    }
    // static getDerivedStateFromProps(props, state) {
    //     let chatTypeSelected = state.chatTypeSelected
    //     let openOnInquirieTypeStateInitedFromRedux = state.openOnInquirieTypeStateInitedFromRedux //defaul : false

    //     if (!openOnInquirieTypeStateInitedFromRedux && chatTypeSelected !== props.settings.channel.openOnInquirieType && props.settings.channel.openOnInquirieType) {
    //         chatTypeSelected = props.settings.channel.openOnInquirieType
    //         openOnInquirieTypeStateInitedFromRedux = true
    //     }

    //     return {
    //         chatTypeSelected: chatTypeSelected,
    //         openOnInquirieTypeStateInitedFromRedux: openOnInquirieTypeStateInitedFromRedux
    //     }
    // }

    checkIfAgentOnConvGroups = (conv, groupFilter) => {
        let convGroupList = conv.groupList
        if (!convGroupList) {
            convGroupList = conv.chat.groupList
        }
        if (!convGroupList) {
            return false
        }

        for (let group of convGroupList) {
            if (groupFilter.find(agent_groupItem => agent_groupItem._id === group || agent_groupItem._id === group._id)) {
                return true
            }
        }
        return false
    }

    popUpLastChangeLogs = async () => {

        if (this.props.lastReadChangeLogTime) {
            try {
                const allNotSeenChangeLogs = (await changeLogReq.getChangeLogs(this.props.lastReadChangeLogTime))?.data?.data
                if (allNotSeenChangeLogs?.length > 0) {
                    this.context.showAlert(this.props.t('Updates'), <ChangeLogs changeLogList={allNotSeenChangeLogs} />, 'md')

                    const updateMeObject = {
                        lastReadChangeLogTime: new Date()
                    }
                    userReq.updateUserMe(updateMeObject)
                }
            } catch (err) {
                console.log(`popUpLastChangeLogs :: Error=${err}`)
            }
        }
    }

    isMsgTypeAllowedByApi = (msgType) => {
        return settings.allowedApiChannels.includes(msgType)
    }

    fixPhoneNum = (clientName) => {
        let idToNewChat = deleteUnnecessaryPhoneChars(clientName)
        idToNewChat = getNumberWithIsraelAreaCode(idToNewChat)
        if (idToNewChat[0] !== '+' || !(/^\d+$/.test(idToNewChat.replace('+', '')))) {
            this.context.showAlert(this.props.t('error'), this.props.t('Please enter a valid phone number'), 'sm')
            throw new Error('Not currect phone number format')
        }

        return idToNewChat
    }

    openNewApiConvByMsgTypeAndClientName = (msgType, clientName, msgId, startTime, finishTime) => {
        let fixedClientName = clientName
        if (!this.isMsgTypeAllowedByApi(msgType)) return
        try {
            if (msgType === 'whatsapp' || msgType === 'sms')
                fixedClientName = this.fixPhoneNum(fixedClientName)
        } catch (e) {
            console.log(e)
        }
        this.handleOnNewConvChannelSelected(msgType)
        this.handleOnNewConvName(fixedClientName)
        setTimeout(() => this.handleOnNewConvClicked(msgId, startTime, finishTime), 0)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let callBack = { ...this.state.callBack }
        let callBackEverySecToCheck = callBack.everySecToCheck

        if (this.props.settings) {// update settings if available
            if (this.props.settings.callBack) {// update callback
                if (this.props.settings.callBack.isEnable && this.props.settings.callBack.everySecToCheck && this.props.settings.callBack.everySecToCheck !== 0 && callBackEverySecToCheck !== this.props.settings.callBack.everySecToCheck) {
                    console.log('changed here@@@@@@@@@@@@@!!!!!!!!!!!!@@@@@@@@@@@')
                    callBack.everySecToCheck = this.props.settings.callBack.everySecToCheck
                    callBack.callBackInterval = setInterval(this.getCallBacks, this.props.settings.callBack.everySecToCheck * 1000)
                    this.setState({ callBack: callBack })
                }
            }
        }

        if (this.props.dashboardSection === 'conv') {
            if (this.props.queryParams.clientName && this.props.queryParams.msgType) {
                if (this.props.queryParams.clientName !== prevProps.queryParams.clientName || this.props.queryParams.msgType !== prevProps.queryParams.msgType) {
                    this.openNewApiConvByMsgTypeAndClientName(this.props.queryParams.msgType, this.props.queryParams.clientName, this.props.queryParams.msgId, this.props.queryParams.startTime, this.props.queryParams.finishTime)
                }
            }
        }

        // if (prevProps.crmPath.crm !== this.props.crmPath.crm) {//todo
        //     this.setState({ showCrmModal: this.props.crmPath.crm === 'crm' })
        // }

    }

    fetchCompanyExt = async () => {
        if (!this.props.companyExts || this.props.companyExts.length === 0) {
            const extensions = await extensionsReq.getExtensions('token')
            this.props.fetchCompanyExtsSuccess(extensions)
        }
    }

    fetchFacebookFeedPosts = () => {
        if (this.props.facebook_pageAccess.length > 0) {
            for (let facebook_pageAccess of this.props.facebook_pageAccess) {
                facebookReq.fetch_FB_FeedPosts(facebook_pageAccess.pageId, 'facebook')
                if (facebook_pageAccess.instagramId) {
                    facebookReq.fetch_FB_FeedPosts(facebook_pageAccess.instagramId, 'ig_media')
                }
            }
        }
    }
    onNewCallCheckConflict = async (oldCall, newCall) => {
        const activeCalls = await callReq.isCallStillLive()
        if (!(activeCalls.inConv && activeCalls.callDetails.callId === oldCall.callId)) {//not a live
            if (oldCall && newCall && oldCall.callId !== newCall.callId) {
                this.props.clearNowCall()
            }
            if (this.state.isCallStillLiveIntervalObj) {
                clearInterval(this.state.isCallStillLiveIntervalObj)
            }
            if (this.props.enableGetCallerId) {
                newCall.callerId = await fetchCallerId(newCall.telephone);
            }
            this.props.CallReceivedEvent(newCall);
            this.fetchAndSetContactName(newCall);
            const isCallStillLiveIntervalObj = setInterval(() => this.isCallStillLive(newCall.callId), isCallStillLiveInterval)
            this.setState({ isCallStillLiveIntervalObj: isCallStillLiveIntervalObj })
        }
    }



    isCallStillLive = async (callId) => {
        const nowTimeStamp = Date.now();
        if (
            !this.state.isCallStillLiveLastCheckTimeStamp ||
            (nowTimeStamp - this.state.isCallStillLiveLastCheckTimeStamp >= isCallStillLiveInterval - 1000)
        ) {
            console.log('isCallStillLive :: Check')
            const activeCalls = await callReq.isCallStillLive()
            if (!(activeCalls.inConv && activeCalls.callDetails.callId === callId)) {//not a live
                if (this.state.isCallStillLiveIntervalObj) {
                    clearInterval(this.state.isCallStillLiveIntervalObj)
                    this.setState({ isCallStillLiveIntervalObj: undefined })
                }
                if (this.props.nowCall && this.props.nowCall.callId === callId) {
                    this.props.clearNowCall()
                }
            }
            this.setState({ isCallStillLiveLastCheckTimeStamp: nowTimeStamp })
        }
    }

    // getClubHotelCallBack = async (project) => {//todo clubhotel
    //     if (!this.props.dialList?.filter(dialItem => dialItem.externalId).length) {
    //         const newCallBack = await callbacksReq.getClubCallBack(project.url, this.props.device)
    //         this.props.dialListAdd([
    //             {
    //                 telephone: newCallBack.telephone,
    //                 projectDesc: newCallBack.projectDesc,
    //                 startTime: newCallBack.startTime,
    //                 externalId: newCallBack.externalId
    //             }
    //         ])
    //         return
    //     }
    // }

    // getItcCallBacks = async (project) => {
    //     let url = project.url
    //     url = url.replace('[project]', project.project)
    //     url = url.replace('[requestedCalls]', this.props.settings.callBack.requestedCalls)
    //     if (this.props.settings.callBack.deleteAfterRead) url = url.replace('[deleteAfterRead]', 1)
    //     else url = url.replace('[deleteAfterRead]', 0)
    //     url = url.replace('[computerName]', 'Effective')
    //     if (this.props.agentName) url = url.replace('[osUserName]', this.props.agentName)
    //     if (this.props.device) url = url.replace('[device]', this.props.device)

    //     const res = await axios.get(url)
    //     const resDate = res.data

    //     const parseStringPromise = new Promise((resolve, reject) => {
    //         parseString(resDate, function (err, result) {
    //             try {
    //                 const callBackRes = result.NewDataSet.Table[0]

    //                 resolve(callBackRes)
    //             } catch (e) {
    //                 reject(e)
    //             }
    //         });
    //     })
    //     const callBackRes = await parseStringPromise
    //     console.log(callBackRes)
    //     console.log(new Date(callBackRes['callTime'][0]))
    //     this.props.dialListAdd([
    //         {
    //             telephone: callBackRes['telephone'][0],
    //             projectDesc: callBackRes['projectDesc'][0],
    //             startTime: new Date(callBackRes['callTime'][0])
    //         }
    //     ])
    //     return
    // }

    getCallBacks = async () => {
        console.log('CallBack Now!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
        const callBackProjects = this.props.settings.callBack.callBackProjects
        //check if on setting add callback when on call or call from diallist 
        if (!this.props.isDialerActive) {
            return
        }
        if (!this.props.settings.callBack.addCallBacksWhenDialerOpen &&
            ((this.state.nowCallFromDiallist && this.state.nowCallFromDiallist._id) ||
                this.props.nowCall)) {
            return
        }
        if (this.props.dialList.find(el => el.projectDesc && el.status === 'waiting')) {
            return
        }

        await callbacksReq.getCallBack()
        // for (let project of callBackProjects) {
        //     try {
        //         const isUserSubscriber = project.subscribers.find(subscriber => subscriber === this.props.device || subscriber === this.props.agentName)
        //         if (isUserSubscriber) {
        //             if (project.projectType === 'ITC') {
        //                 this.getItcCallBacks(project)
        //             }
        //             else if (project.projectType === 'CLUB_CALLBACK') {
        //                 this.getClubHotelCallBack(project)
        //             }
        //         }
        //     } catch (e) {
        //         console.log('ERROR')
        //         console.log(e)
        //     }
        // }
    }



    getChannelNameInHeb = (channel) => {//get channel name from db return name in hebrew
        let channelName = ''
        switch (channel) {
            case 'whatsapp': channelName = this.props.t('whatsapp')//'וואטסאפ'
                break;
            case 'messenger': channelName = this.props.t('messenger')//"מסנג'ר"
                break;
            case 'sms': channelName = this.props.t('sms')//'סמס'
                break;
            case 'instagram': channelName = this.props.t('instagram')//'אינסטגרם'
                break;
            case 'mail': channelName = this.props.t('mail')//'מייל'
                break;
            case 'call': channelName = this.props.t('Telephony')//'טלפוני'
                break;
            case 'webchat': channelName = this.props.t('Chat from the website')//`צ'אט באתר`
                break;
            default: channelName = ''
        }
        return channelName
    }

    runOnDialList = () => {
        let isCallEnable = true
        if (!this.props.isPbxConnected) {
            return console.log('@@@PBX Not Connected@@@')
        }
        if (!this.props.isDialerActive) {
            return console.log('@@@@runOnDialList when isDialerActive not active@@@')
        }
        if (this.props.dialList.length > 0) {

            //@@@@@@@@@@@@@@@@@@@@check bore@@@@@@@@@@@@@@@@@@@@

            let areThereBore = false
            this.props.dialList.forEach(dialItem => {//bore always 60 sec
                if (dialItem.status === 'bore') {
                    console.log(dialItem.status)
                    areThereBore = true
                    if (!this.props.nowCall && !this.state.nowCallFromDiallist._id && this.state.boreCount > 5 && isCallEnable) {
                        console.log('oooooook borecount=')
                        console.log(this.state.boreCount)
                        this.setState({
                            boreCount: 0,
                            nowCallFromDiallist:
                            {
                                _id: dialItem._id,
                                telephone: dialItem.telephone,
                                status: dialItem.status,
                                projectDesc: dialItem.projectDesc,
                                obj: dialItem
                            }
                        });
                        if (this.props.settings.calls.autoDial) {//changed
                            this.props.makeCall(dialItem.telephone);
                        }
                        else {
                            this.setState({ isNewChatOpen: true })
                        }
                        isCallEnable = false
                        return
                    }
                    else {
                        let boreCount = this.state.boreCount
                        boreCount++
                        this.setState({ boreCount: boreCount })
                        // console.log('borecount=')
                        // console.log(boreCount)
                        isCallEnable = false
                        return
                    }

                }
            })
            if (areThereBore === true) return

            //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

            this.props.dialList.forEach(dialItem => {
                if (new Date(dialItem.startTime) < new Date() && dialItem.status !== 'notactive') {//time to call

                    if (!this.props.nowCall && !this.state.nowCallFromDiallist._id && isCallEnable) {//try to call

                        this.setState({
                            nowCallFromDiallist:
                            {
                                _id: dialItem._id,
                                telephone: dialItem.telephone,
                                status: dialItem.status,
                                projectDesc: dialItem.projectDesc,
                                obj: dialItem
                            }
                        });

                        if (dialItem.status !== 'waiting') {
                            this.props.dialListUpdate({
                                all: false,
                                data: [
                                    {
                                        _id: dialItem._id,
                                        status: 'waiting'
                                    }
                                ]
                            });//Change status to waiting
                        }
                        if (this.props.settings.calls.autoDial) {//changed
                            this.props.makeCall(dialItem.telephone);
                        }
                        isCallEnable = false
                        return;
                    }
                    else {//change from postponed to waiting
                        if (dialItem.status !== 'waiting') {
                            this.props.dialListUpdate({
                                all: false,
                                data: [
                                    {
                                        _id: dialItem._id,
                                        status: 'waiting'
                                    }
                                ]
                            })//Change to waiting
                        }
                    }
                }
            });
        }
    }

    handleOnHumanAgentSend = (channelId) => {
        setTimeout(this.handleSendClicked, 0)
        this.setState({ tag: 'HUMAN_AGENT', lastChannelId: channelId, modal: { show: false } })
    }

    handleModalOnHide = () => {
        this.setState({ tag: undefined, lastChannelId: undefined, modal: { show: false } })
    }

    openModal_LessThen7DaysNotify = (channelId) => {
        let copyModal = { ...this.state.modal }
        copyModal.modalTitle = this.props.t('Response to inquiry after 24 hours from the time of the inquiry')
        copyModal.modalBody = this.props.t('Special approval is required for an inquiry that cannot be responded to within 24 hours. Messages can be sent up to 7 days from the last inquiry. Would you like to allow a response within the 7-day period?')
        copyModal.show = true
        copyModal.onHide = this.handleModalOnHide
        copyModal.btnList = [
            {
                title: this.props.t('Cancel'),
                action: 'close',
                onClick: this.handleModalOnHide
            }
            ,
            {
                title: this.props.t('confirm'),
                onClick: () => this.handleOnHumanAgentSend(channelId)
            }
        ]
        this.setState({ modal: copyModal })
    }

    openModal_cantSendMsgMoreThen7Days = () => {
        let copyModal = { ...this.state.modal }
        copyModal.modalTitle = this.props.t('Response to inquiry after 7 days from the time the inquiry was received')
        copyModal.modalBody = this.props.t('It is not possible to send a response to an inquiry after 7 days from the date it was received.')
        copyModal.show = true
        copyModal.onHide = this.handleModalOnHide
        copyModal.btnList = [
            {
                title: this.props.t('Cancel'),
                action: 'close',
                onClick: this.handleModalOnHide
            }
        ]
        this.setState({ tag: undefined, lastChannelId: undefined, modal: copyModal })
    }

    openModal_cantSendMsg = () => {
        let copyModal = { ...this.state.modal }
        copyModal.modalTitle = this.props.t('Outgoing message that is not a response')
        copyModal.modalBody = this.props.t('It is not possible to send a message that is not a response to an inquiry.')
        copyModal.show = true
        copyModal.onHide = this.handleModalOnHide
        copyModal.btnList = [
            {
                title: this.props.t('Cancel'),
                action: 'close',
                onClick: this.handleModalOnHide
            }
        ]
        this.setState({ tag: undefined, lastChannelId: undefined, modal: copyModal })
    }

    handleSendClicked = () => {
        let msg = this.state.msgTextBox;
        let clientName = this.props.chatSelectedSenderName;
        let channel = this.props.chatSelectedChannel;
        let channelId = this.state.lastChannelId
        let selectedMsg = this.props.selectedMsg
        let selectedMsgAction = this.props.selectedMsgAction
        let cbFunction = this.popupResponseMessage
        const isHebrew = this.state.applicationLanguage === 'he';

        if (this.props.chatSelectedChannel === 'mail' && isHebrew) {
            msg = `<div dir="rtl">${msg}</div>`;
        }

        if (this.props.settings.channel.attachToBeginMsg && channel !== 'facebook' && channel !== 'ig_media') {
            msg = this.props.settings.channel.attachToBeginMsg.replace('{name}', this.props.name) + ' ' + msg
        }

        // Check if message is empty or contains only whitespace/HTML tags
        let textContent = msg.replace(/<[^>]*>/g, '').trim();

        if (this.props.settings.channel.attachToBeginMsg && channel !== 'facebook' && channel !== 'ig_media') {
            const templatePrefix = this.props.settings.channel.attachToBeginMsg.replace('{name}', this.props.name);
            if (textContent.startsWith(templatePrefix)) {
                textContent = textContent.substring(templatePrefix.length).trim();
            }
        }

        if ((textContent === '' && !this.state.fileToSend)
            ||
            (channel === 'mail' && this.state.mailSubject.trim() === '' && !this.props.selectedMsgAction)) {
            // alert('יש למלא את כל שדות החובה');
            this.context.showAlert(this.props.t('error'), this.props.t('All required fields must be filled in.'), 'sm')
            return
        }

        if (!this.state.tag && (channel === 'instagram' || channel === 'messenger')) {// instagram or messanger
            let lastClientMsg
            for (let i = this.props.msgs.length - 1; i > -1; i--) {
                if (!this.props.msgs[i].isAgent) {
                    lastClientMsg = this.props.msgs[i]
                    break;
                }
            }
            if (lastClientMsg) {
                const dayDiffBetweenTodayToMsg = ((new Date()).getTime() - (new Date(lastClientMsg.msgTime)).getTime()) / 1000 / 60 / 60 / 24
                if (dayDiffBetweenTodayToMsg > 1 && dayDiffBetweenTodayToMsg < 7) {
                    return this.openModal_LessThen7DaysNotify(lastClientMsg.channelId)
                }
                else if (dayDiffBetweenTodayToMsg > 7) {
                    return this.openModal_cantSendMsgMoreThen7Days()
                }
                else {
                    channelId = lastClientMsg.channelId
                }
            }
            else {
                return this.openModal_cantSendMsg()
            }
        }
        // else if (channel === 'mail') {
        //     // console.log(msg)
        //     msg = `<p>${msg.replace(/\n/g,'<br/>')}</p>` 
        // }
        else if (channel === 'facebook' || channel === 'ig_media') {
            channelId = this.props.chatSelectedChannelId
            if (this.props.msgs && this.props.msgs.length > 0) {//its a comment
                if (channel === 'facebook' && this.state.fileToSend && this.state.fileToSend.length > 1) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Cant send comment with more then one photo'), 'sm')//alert(this.props.t('Cant send comment with more then one photo'))
                }
                else if (channel === 'ig_media' && this.state.fileToSend && this.state.fileToSend.length > 0) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Cant send comment with media'), 'sm')//alert(this.props.t('Cant send comment with media'))
                }
            }
            else {// its a post
                if (this.props.selectedConv) {//that post was created before so now it was deleted from instagram app
                    return this.context.showAlert(this.props.t('error'), this.props.t('Post deleted you cant comment'), 'sm')//alert(this.props.t('Post deleted you cant comment'))
                }
                else if (channel === 'ig_media' && (!this.state.fileToSend || (this.state.fileToSend && this.state.fileToSend.length === 0))) {//if it gonna post on instagram media post
                    return this.context.showAlert(this.props.t('error'), this.props.t('there must be minimum one media'), 'sm')//alert(this.props.t('there must be minimum one media'))
                }
                else if (channel === 'ig_media' && this.state.fileToSend && this.state.fileToSend.length > 10) {//if it gonna post on instagram media post
                    return this.context.showAlert(this.props.t('error'), this.props.t('Up to 10 media can be send'), 'sm')//alert(this.props.t('Up to 10 media can be send'))
                }
            }

            // if (!selectedMsg && !selectedMsgAction && this.props.msgs && this.props.msgs[0]) {//its a reply to a post and not comment
            //     selectedMsg = this.props.msgs[0]
            //     selectedMsgAction = 'REPLY'
            // }

            if (selectedMsgAction === 'FORWARD_TO_OTHER_CHANNEL' && this.props.selectedMsgOpt?.forwardToChannel && this.props.selectedMsgOpt?.forwardToClientName) {
                clientName = this.props.selectedMsgOpt.forwardToClientName
                channel = this.props.selectedMsgOpt.forwardToChannel
                // cbFunction = this.popupResponseMessage
            }
        }

        if (channel === 'youtube' || channel === 'facebook' || channel === 'ig_media') { //check if its comment or reply
            if (!selectedMsg && !selectedMsgAction && this.props.msgs && this.props.msgs[0]) {//its a reply to a post and not comment
                selectedMsg = this.props.msgs[0]
                selectedMsgAction = 'REPLY'
            }
        }

        let opt = { completed: false, isPublic: false, subject: this.state.mailSubject, selectedMsg: selectedMsg, selectedMsgAction: selectedMsgAction, msgMails: this.state.mailTo.toLowerCase(), msgCC: this.state.mailCc.toLowerCase(), msgBCC: this.state.mailBcc.toLowerCase(), tag: this.state.tag, channelId: channelId }
        this.props.onSendClicked(clientName, channel, msg, this.state.fileToSend, opt, cbFunction)
        this.props.selectMsg(undefined, undefined, undefined)
        this.setState({ fileToSend: null, isFileToSendSelected: false, msgTextBox: '', tag: undefined, lastChannelId: undefined, msgTextBoxDisplay: '', mailSubject: '', mailTo: this.props.chatSelectedSenderName + ',', mailCc: '', mailBcc: '' });
    }

    popupResponseMessage = (message, status) => {
        let statusTranslation
        let messageTranslation = message ? this.props.t(message) : this.props.t('unknown error')
        switch (status) {
            case 400:
                statusTranslation = this.props.t('fail')
                break;
            case 200:
                statusTranslation = this.props.t('success')
                break;
            case 201:
                statusTranslation = this.props.t('success')
                break;
            default:
                statusTranslation = this.props.t('error')
                break;

        }

        this.context.showAlert(statusTranslation, messageTranslation, 'sm')
    }

    handleNewChatChar = (event) => {
        // console.log('start')
        // console.log(event.target.value)
        // console.log('end')
        this.setState({ msgTextBox: event.target.value, msgTextBoxDisplay: event.target.value });
    }

    handleOnChatChannelFilterSelected = (chatChannelFilterSelected) => {
        let toFetchGroupsList = undefined
        if (this.state.groupFilterSelected) {
            toFetchGroupsList = [this.state.groupFilterSelected]
        }

        let selectedMsgTypesFilter = []
        if (chatChannelFilterSelected !== 'all') {
            selectedMsgTypesFilter = this.state.selectedMsgTypesFilter ? JSON.parse(JSON.stringify(this.state.selectedMsgTypesFilter)) : []
            const msgTypeIndex = selectedMsgTypesFilter.findIndex((msgType) => msgType === chatChannelFilterSelected)

            if (msgTypeIndex > -1) {
                selectedMsgTypesFilter.splice(msgTypeIndex, 1)
            }
            else {
                selectedMsgTypesFilter.push(chatChannelFilterSelected)
            }
        }

        this.activeFetchChats(this.state.chatTypeSelected, this.state.searchTextBox, selectedMsgTypesFilter, toFetchGroupsList)
        this.setState({ selectedMsgTypesFilter })
    }



    handleOnGroupFilterSelected = (groupFilterSelected) => {
        let toFetchGroupsList = undefined
        if (groupFilterSelected) {
            toFetchGroupsList = [groupFilterSelected]
        }
        this.activeFetchChats(this.state.chatTypeSelected, this.state.searchTextBox, this.state.selectedMsgTypesFilter, toFetchGroupsList)
        this.setState({ groupFilterSelected: groupFilterSelected })
    }


    handleContactChatSelected = async (senderName, channel, windowId, selectedChatCrmContact, openChatAnyWay, chatSelectedChannelId) => {
        if (!this.state.selectMultipleBtnClicked || openChatAnyWay) {
            if (this.props.chatSelectedChannel !== channel || this.props.chatSelectedSenderName !== senderName) {
                this.setState({ phoneWindowToShow: windowId, isNewChatOpen: false, isFileToSendSelected: false, fileToSend: null, settingsSelected: 4, actionIdSelected: 1, selectedChatCrmContact: selectedChatCrmContact });
                this.state.socket.emit('join', { agent: this.props.agentName, conv: senderName + this.props.companyId + channel, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                if (channel === 'mail') {
                    this.setState({ mailTo: senderName + ',', mailCc: '', mailBcc: '', mailSubject: '' })
                }
                if (channel === 'youtube') {
                    await googleReq.youtubeSyncVideoComments(senderName)
                }


                this.props.onSelectChat(senderName, channel, 0, 0, chatSelectedChannelId);
                // this.props.fetchAgents();
                this.props.selectMsg(undefined, undefined, undefined)
                this.setState({ msgTextBox: '', msgTextBoxDisplay: '' })
            }
        }
        else {
            this.props.multiSelectUnselectChat(senderName, channel)
        }

    }


    handleOnContactSelect = (contactId) => {
        console.log('contactId')
        console.log(contactId)
        this.props.selectContactSuccess(contactId)
    }

    handleOnFetchMoreChatMsgsClicked = () => {
        this.props.onSelectChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, this.props.loadedMsgCount, this.props.loadedMsgFromPagingCount, this.props.chatSelectedChannelId);
    }

    handleOnSelectAllClicked = () => {//for chats
        if (this.props.conversations.length === this.props.multiSelectCount) {
            this.props.multiSelectUnselectAllChat('unSelectall')
        }
        else {
            this.props.multiSelectUnselectAllChat('selectall')
        }
        if (!this.state.selectMultipleBtnClicked) {
            this.setState({ selectMultipleBtnClicked: true })
        }

    }

    handleOnSelectAllCallsClicked = () => {
        if (this.props.calls.length === this.props.multiSelectCallsCount) {
            this.props.multiSelectUnselectAllCalls('unSelectall')
        }
        else {
            this.props.multiSelectUnselectAllCalls('selectall')
        }
        if (!this.state.selectMultipleBtnClicked) {
            this.setState({ selectMultipleBtnClicked: true })
        }

    }

    handleOnSelectAllDialListClicked = () => {
        if (this.props.dialList.length === this.props.multiSelectdialListCount) {
            this.props.multiSelectUnselectAllDialList('unSelectall')
        }
        else {
            this.props.multiSelectUnselectAllDialList('selectall')
        }
        if (!this.state.selectMultipleBtnClicked) {
            this.setState({ selectMultipleBtnClicked: true })
        }
    }

    handleOnCategorySelected = (CategoryId) => {
        setTimeout(() => this.activeFetchChats(CategoryId, this.state.searchTextBox, [], undefined), 0)
        this.setState({ chatTypeSelected: CategoryId, phoneWindowToShow: 1, selectedChatsPage: 0, groupFilterSelected: undefined, selectedMsgTypesFilter: [] })
    }
    handleOnSettingsSelect = (settingId) => {
        if (settingId === 4 && !this.props.chatSelectedSenderName) {
            // alert('כדי לעשות את הפעולה הזאת אתה צריך לבחור שיחה בהודעות');
            this.context.showAlert(this.props.t('error'), this.props.t('Up to 10 media can be send'), 'sm')
        }
        else if (settingId === 6 && !this.state.dialItemSelected._id) {
            // alert('כדי לעשות את הפעולה הזאת אתה צריך לבחור שיחה בחייגן');
            this.context.showAlert(this.props.t('error'), this.props.t('To perform this action, you need to select a call in the dialer.'), 'sm')
        }
        else if (settingId === 5 && !this.state.callSelected._id) {
            // alert('כדי לעשות את הפעולה הזאת אתה צריך לבחור שיחה ברשימת חיוג');
            this.context.showAlert(this.props.t('error'), this.props.t('To perform this action, you need to select a call from the dial list.'), 'sm')
        }
        else if (settingId === 1) {
            this.setState({ isNewChatOpen: true })
            this.props.clearMsgs()
        }
        else if (settingId === 7) {
            this.setState({ isDialerOpen: true })
        }//open dialer
        else {
            this.setState({ settingsSelected: settingId, actionIdSelected: 1 })
        }

    }

    handleChangeWindowToShow = (windowId) => {
        this.setState({ phoneWindowToShow: windowId })
    }


    activeFetchChats = (type, text = '', channelFilter = [], groupFilterSelected) => {
        if (type !== 2 && this.props.supportedMsgTypes.length) {
            if (!channelFilter?.length) channelFilter = this.props.supportedMsgTypes
            else {
                channelFilter = this.props.supportedMsgTypes.filter((msgType => channelFilter.includes(msgType)))
            }
        }
        this.props.multiSelectUnselectAllCalls('unSelectall')
        text = text.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        // if (text.match(/^[0-9]+$/)) {
        //     text = text.replace(new RegExp("05", "g"), '9725')
        // }
        if (text.startsWith("05")) {
            text = "9725" + text.substring(2)
        }
        const startIndex = this.state.selectedChatsPage * jumpItemsInPage
        const startIndexCalls = this.state.selectedCallsPage * jumpItemsInPage
        const startIndexDialList = this.state.selectedDialListPage * jumpItemsInPage
        const startIndexContact = this.state.selectedContactPage * jumpItemsInPage

        this.props.fetchCalls(text, jumpItemsInPage, startIndexCalls);
        this.props.fetchDialList(text, jumpItemsInPage, startIndexDialList);
        this.props.fetchContacts(text, jumpItemsInPage, startIndexContact)
        // console.log('startIndex=' + startIndex)
        // console.log('jumpItemsInPage=' + jumpItemsInPage)

        let fetchWithGroupFilterList = undefined
        if (groupFilterSelected) {
            fetchWithGroupFilterList = groupFilterSelected
        }
        else if (type === 7) {
            if (this.props.agent_groupList.length > 0) {
                fetchWithGroupFilterList = this.props.agent_groupList
            }
            else {
                fetchWithGroupFilterList = [{ _id: '111111111111111111111111' }]
            }
        }

        switch (type) {
            case 1://new inquiries
                this.props.setCategory(false, true)
                this.props.onLoadFetchChats({ completed: false, isPublic: true, viewAll: false, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'newInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 2://in progress inquiries
                this.props.setCategory(false, false)
                this.props.onLoadFetchChats({ completed: false, isPublic: false, viewAll: false, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'inProgressInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 3://historical inquiries
                this.props.setCategory(true, false)
                this.props.onLoadFetchChats({ completed: true, isPublic: false, viewAll: false, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'historicalInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 4://all agent open Chats
                this.props.setCategory(true, true)
                this.props.onLoadFetchChats({ completed: false, isPublic: true, viewAll: true, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'allAgentInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 5://all Agent History chats
                this.props.setCategory(true, false)
                this.props.onLoadFetchChats({ completed: true, isPublic: false, viewAll: true, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'allAgentHistoricalInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 6://all Agent chats 
                this.props.setCategory(true, true)
                this.props.onLoadFetchChats({ completed: true, isPublic: false, viewAll: true, completedAndNot: true, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'allAgentInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            case 7://new group inquiries 
                this.props.setCategory(false, true)
                this.props.onLoadFetchChats({ completed: false, isPublic: true, viewAll: false, searchWord: text, startIndex: startIndex, numberOfChatsToFetch: jumpItemsInPage, channelFilter: channelFilter, agent_groupList: fetchWithGroupFilterList })
                this.state.socket.emit('join', { agent: this.props.agentName, category: 'newInquiries' + this.props.companyId, companyId: this.props.companyId }, (error) => {
                    if (error) {
                        console.log(error)
                    }
                })
                break;
            default: return;
        }
    }

    handleOnSearchchar = (event) => { // todo 29.07.2024
        event.preventDefault();
        let toFetchGroupsList = undefined
        const newValue = event.target.value
        const { chatTypeSelected, selectedMsgTypesFilter, groupFilterSelected, mainSearchDebounceSetTimeoutId: oldMainSearchDebounceSetTimeoutId } = this.state
        if (groupFilterSelected) {
            toFetchGroupsList = [groupFilterSelected]
        }
        if (oldMainSearchDebounceSetTimeoutId) {
            clearTimeout(oldMainSearchDebounceSetTimeoutId)
        }
        const mainSearchDebounceSetTimeoutId = setTimeout(() => {
            this.activeFetchChats(chatTypeSelected, newValue, selectedMsgTypesFilter, toFetchGroupsList);
            this.setState({ mainSearchDebounceSetTimeoutId: undefined })
        }, settings.MAIN_SEARCH_DEBOUNCE_DELAY_MS || 500)

        this.setState({ searchTextBox: newValue, selectedChatsPage: 0, mainSearchDebounceSetTimeoutId });
    }

    handleSearchSendClicked = () => {
        if (this.props.permissionType > 3 || this.props.companyDetails.appAccess === 'DIALER') return

        this.activeFetchChats(6, this.state.searchTextBox, [], undefined);
        this.setState({ selectedChatsPage: 0, chatTypeSelected: 6 })
    }

    handleOnChatActionSelected = async (actionId, remarks = '') => {
        this.setState({ actionIdSelected: actionId })
        switch (actionId) {
            case 1: //Transfer to new injuiries
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: false, isPublic: true })
                }
                else {
                    for (let conv of this.props.conversations) {
                        if (conv.isChatMultiSelected) {
                            this.props.updateChat(conv.clientName, conv.msgType, { completed: false, isPublic: true })
                            await delayNow(delayTimeInMlSec)
                        }
                    }

                }
                // this.props.clearMsgs();
                this.setState({ settingsSelected: 4 })
                break;
            case 2://Transfer to History
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: true, isPublic: false, remarks: remarks })
                }
                else {
                    for (let conv of this.props.conversations) {
                        if (conv.isChatMultiSelected) {
                            this.props.updateChat(conv.clientName, conv.msgType, { completed: true, isPublic: false, remarks: remarks })
                            await delayNow(delayTimeInMlSec)
                        }
                    }

                }
                // this.props.clearMsgs();
                this.setState({ settingsSelected: 4 })
                break;
            case 3://Add agent to Conv
                // this.props.fetchAgents()
                break;
            case 4://Delete Conv
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.deleteChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel);
                }
                else {
                    for (let conv of this.props.conversations) {
                        if (conv.isChatMultiSelected) {
                            this.props.deleteChat(conv.clientName, conv.msgType);
                            await delayNow(delayTimeInMlSec)
                        }
                    }
                    // this.props.conversations.forEach(conv => {
                    //     if (conv.isChatMultiSelected) {
                    //         this.props.deleteChat(conv.clientName, conv.msgType);
                    //         await delayNow(delayTimeInMlSec)
                    //     }
                    // })
                }
                this.setState({ settingsSelected: 4 })
                break;
            case 5://Open Crm Source

                this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, this.props.selectedConv?.crmId, this.props.urlOnNewContact, this.props.chatSelectedSenderName, true)
                // if (!this.props.companyDetails.crmOnOpenContactWindowSendApiReq) {
                //     if (!this.props.selectedConv || !this.props.selectedConv.crmId) {//open new contact
                //         if (this.props.chatSelectedSenderName !== undefined && this.props.chatSelectedSenderName !== null) {
                //             window.open(this.props.urlOnNewContact.replace('[Phone]', this.props.chatSelectedSenderName.replace('+972', '0').replace('-', '')), "_blank") //to open new page
                //         }
                //     }
                //     else {
                //         window.open(this.props.selectedConv.crmId.siteUrl, "_blank") //to open new page
                //     }
                // }
                // else {
                //     if (this.props.selectedConv?.crmId) {
                //         const crmId = typeof this.props.selectedConv.crmId === 'object' ? this.props.selectedConv.crmId._id : this.props.selectedConv.crmId
                //         try {
                //             await crmReq.openContactOnCrm(crmId)
                //             this.context.showAlert(this.props.t('success'), this.props.t('contact has been successfully loaded in the crm'), 'sm')
                //         } catch (e) {
                //             this.context.showAlert(this.props.t('fail'), this.props.t('problem loading a contact in the crm'), 'sm')
                //         }
                //     }
                // }
                this.setState({ settingsSelected: 4 })
                break;

            case 6://crm update to the chat 
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.fetchChatUpdatedCrmData([{ clientName: this.props.chatSelectedSenderName, msgType: this.props.chatSelectedChannel, isChatMultiSelected: true }])
                }
                else {
                    this.props.fetchChatUpdatedCrmData(this.props.conversations)
                }
                this.setState({ settingsSelected: 4 })
                break;
            case 7://sync facebook chat
                this.handleOnReloadClicked()
                break;
            case 9://block whatsapp user
                if (!this.props.selectedConv) return
                try {
                    await chatReq.blockWhatsappUser(this.props.selectedConv._id)
                    const updatedChat = { ...this.props.selectedConv, blockedVia360Api: true, blockedVia360ApiAt: new Date(), blockedVia360ApiBy: this.props.agentName }
                    this.props.updateConversation({ chat: updatedChat }, this.state.chatTypeSelected, this.props.agentName)
                    this.context.showAlert(this.props.t('success'), this.props.t('The user has been blocked successfully'), 'sm')
                } catch (e) {
                    const errorMsg = e.response?.data?.message || this.props.t('Failed to block user')
                    this.context.showAlert(this.props.t('fail'), errorMsg, 'sm')
                }
                this.setState({ settingsSelected: 4 })
                break;
            case 8://copy to clipboard
                if (!this.props.selectedConv) return
                const reqQuery = {
                    chat: this.props.selectedConv._id
                }
                let name
                console.log(typeof this.props.selectedConv.crmId)
                if (typeof this.props.selectedConv.crmId === 'object' && this.props.selectedConv.crmId?.name) {
                    name = this.props.selectedConv.crmId.name
                }
                else if (this.props.selectedConv.displayName) {
                    name = this.props.selectedConv.displayName
                }
                const copyToClipboard = await msgReq.formatMsgArrToClipboard(reqQuery, this.props.selectedConv.msgType, name)
                navigator.clipboard.writeText(copyToClipboard)
                this.context.showAlert(this.props.t('success'), this.props.t('The conversation was copied successfully.'), 'sm')
                break;
            default: return null
        }
    }

    async openContactCrmWindow(
        sendApi = this.props.companyDetails.crmOnOpenContactWindowSendApiReq,
        crm,
        newContactUrl = this.props.urlOnNewContact,
        searchId,
        showNotificationOnContactLoad = false,
        relatedCallId = null
    ) {
        if (!sendApi) {
            if (!crm) {//open new contact
                if (searchId && newContactUrl) {
                    window.open(newContactUrl.replace('[Phone]', searchId.replace('+972', '0').replace(/-/g, '')), "_blank") //to open new page
                }
            }
            else if (crm.siteUrl) {
                window.open(crm.siteUrl, "_blank") //to open new page
            }
        }
        else {
            if (crm) {
                if (this.props.settings.calls.alwaysOpenCrmPopup) {
                  
                    const siteUrl = typeof crm === 'object' ? crm.siteUrl : null
                    if (siteUrl) {
                        window.open(siteUrl, '_blank')
                    }
                } else {
                    
                    const crmId = typeof crm === 'object' ? crm._id : crm
                    try {
                        await crmReq.openContactOnCrm(crmId)
                        showNotificationOnContactLoad && this.context.showAlert(this.props.t('success'), this.props.t('contact has been successfully loaded in the crm'), 'sm')
                    } catch (e) {
                        showNotificationOnContactLoad && this.context.showAlert(this.props.t('fail'), this.props.t('problem loading a contact in the crm'), 'sm')
                    }
                }
            }
            if (!crm && this.props.settings.calls.alwaysOpenCrmPopup && !this.props.settings.calls.passRelatedCallId) {
                const newWindow = window.open('about:blank', '_blank')
                try {
                    const popupUrl = await crmReq.openContactOnCrmAlways('null', searchId)
                    if (popupUrl && newWindow) {
                        newWindow.location.href = popupUrl
                    } else if (newWindow) {
                        newWindow.close()
                    }
                } catch (error) {
                    console.log('error', error)
                    if (newWindow) newWindow.close()
                }
            }
            if (!crm && this.props.settings.calls.alwaysOpenCrmPopup && this.props.settings.calls.passRelatedCallId) {
                try {
                    await crmReq.openContactOnCrmAlwaysWithRelatedCallId('null', searchId, relatedCallId)
                } catch (error) {
                    console.log('error', error)
                }
            }
            if (this.props.settings.calls.popUpSiteUrlFromCrmApi && crm) {
                const siteUrl = typeof crm === 'object' ? crm.siteUrl : null
                if (siteUrl) {
                    window.open(siteUrl, '_blank')
                }
            }
        }
    }

    handleOnAgentAddToChatClicked = (agentName, action) => {
        if (action === 'add') {
            this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: false, isPublic: false, newAgent: agentName });
        }
        else if (action === 'remove') {
            this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: false, isPublic: false, removeAgentFromChat: agentName });
        }

    }
    handleOnAddChatToGroupClicked = async (uniqGroupName, isForward) => {
        if (!this.state.selectMultipleBtnClicked) {
            if (uniqGroupName && this.props.chatSelectedSenderName && this.props.chatSelectedChannel) {
                await groupsReq.addChatToGroup(uniqGroupName, this.props.chatSelectedSenderName, this.props.chatSelectedChannel, isForward)
                this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: false, isPublic: true })
            }
        }
        else {
            for (let conv of this.props.conversations) {
                if (conv.isChatMultiSelected) {
                    if (uniqGroupName && conv.clientName && conv.msgType) {
                        await groupsReq.addChatToGroup(uniqGroupName, conv.clientName, conv.msgType, isForward)
                        this.props.updateChat(conv.clientName, conv.msgType, { completed: false, isPublic: true })
                        await delayNow(delayTimeInMlSec)
                    }
                }
            }

        }
    }
    handleOnRemoveChatFromGroup = async (uniqGroupName) => {
        if (!this.state.selectMultipleBtnClicked) {
            await groupsReq.removeChatFromGroup(uniqGroupName, this.props.chatSelectedSenderName, this.props.chatSelectedChannel)
            this.props.updateChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, { completed: false, isPublic: true })
        }
    }

    // insertNewMsg = (clientName,msgType,msgBody,msgStyle)=>{
    //     msgReq.addMsg(clientName,msgType,msgBody,msgStyle)
    // }

    removeAgentsFromConv = async (clientName, msgType, agents) => {
        for (let agent of agents) {
            this.props.updateChat(clientName, msgType, { completed: false, isPublic: false, removeAgentFromChat: agent.agent })
            await delayNow(delayTimeInMlSec)
        }
    }

    handleOnAgentForwardClicked = async (agentName, noteMsg, onlyNote) => {
        let updateChatCb = (selectedChatClientName, selectedChatChannel, agents, noteMsg) => {
            if (noteMsg) {
                return () => {
                    msgReq.addMsg(selectedChatClientName, selectedChatChannel, noteMsg, 'note')
                    this.removeAgentsFromConv(selectedChatClientName, selectedChatChannel, agents)
                }
            }
            else {
                return () => this.removeAgentsFromConv(selectedChatClientName, selectedChatChannel, agents)
            }
        }

        // const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
        if (!this.state.selectMultipleBtnClicked) {
            let allConvAgents = [...this.props.selectedConv.agentName]
            let selectedChatClientName = this.props.chatSelectedSenderName
            let selectedChatChannel = this.props.chatSelectedChannel
            const indexOfLoggedAgent = allConvAgents.findIndex(agent => agent.agent === agentName)
            if (indexOfLoggedAgent > -1) {
                allConvAgents.splice(indexOfLoggedAgent, 1)
            }

            this.props.updateChat(selectedChatClientName, selectedChatChannel, { completed: false, isPublic: false, newAgent: agentName, isForwarding: true },
                updateChatCb(selectedChatClientName, selectedChatChannel, allConvAgents, noteMsg))
        }
        else {
            const convrs = JSON.parse(JSON.stringify(this.props.conversations))
            for (let conv of convrs) {
                if (conv.isChatMultiSelected) {
                    let allConvAgents = conv.agentName
                    let selectedChatClientName = conv.clientName
                    let selectedChatChannel = conv.msgType
                    const indexOfLoggedAgent = allConvAgents.findIndex(agent => agent.agent === agentName)
                    if (indexOfLoggedAgent > -1) {
                        allConvAgents.splice(indexOfLoggedAgent, 1)
                    }
                    await this.props.updateChat(selectedChatClientName, selectedChatChannel, { completed: false, isPublic: false, newAgent: agentName },
                        updateChatCb(selectedChatClientName, selectedChatChannel, allConvAgents, noteMsg))

                }
            }


        }
    }

    handleNewCharOnConvName = (event) => {
        event.preventDefault();
        this.setState({ NewConvNameTextBox: event.target.value });
    }

    handleOnNewConvName = (convName) => {
        this.setState({ NewConvNameTextBox: convName });
    }

    // getNumberWithIsraelAreaCode = (phone) => {
    //     if (phone.substring(0, 1) === '0') return phone.replace('0', '+972')
    //     return phone

    // }
    // deleteAreaCode = (phone) => {
    //     if (phone.substring(0, 5) === '+9725') return phone.replace('+9725', '05').replace('-', '').replace('-', '').replace('-', '').replace('-', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '').replace('(', '').replace('(', '').replace('(', '').replace('(', '').replace(')', '').replace(')', '').replace(')', '').replace(')', '')
    //     return phone.replace('-', '').replace('-', '').replace('-', '').replace('-', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(')', '').replace(')', '').replace(')', '').replace(')', '').replace('(', '').replace('(', '').replace('(', '').replace('(', '')
    // }


    onSelectConv = (clientName, msgType, channelId) => {
        const NewSelectedChannelObj = {
            instagramId: channelId,
            pageId: channelId
        }

        // Handle mail with separate to/cc fields
        if (msgType === 'mail' && typeof clientName === 'object' && clientName.to) {
            this.setState({
                NewConvNameTextBox: clientName.to,
                NewConvSelectedChannel: msgType,
                NewSelectedChannelObj,
                mailTo: clientName.to + ',',
                mailCc: clientName.cc || '',
                mailBcc: '',
                mailSubject: ''
            })
            setTimeout(this.handleOnNewConvClicked, 0)
        } else {
            this.setState({ NewConvNameTextBox: clientName, NewConvSelectedChannel: msgType, NewSelectedChannelObj })
            setTimeout(this.handleOnNewConvClicked, 0)
        }
    }

    handleOnNewConvClicked = (msgId, startTime, finishTime) => {
        if (this.state.NewConvNameTextBox.length < 2) {
            // alert('מזהה לקוח חייב להכיל יותר מ-2 תווים');
            this.context.showAlert(this.props.t('error'), this.props.t('Customer ID must contain more than 2 characters.'), 'sm')
        }
        else {
            let channelId = undefined
            let idToNewChat = this.state.NewConvNameTextBox
            if (this.state.NewConvSelectedChannel === 'whatsapp' || this.state.NewConvSelectedChannel === 'sms') {
                // console.log('isnum=' + idToNewChat)
                idToNewChat = deleteUnnecessaryPhoneChars(idToNewChat)
                // console.log('isnum=' + idToNewChat)
                // idToNewChat = this.deleteAreaCode(idToNewChat)
                idToNewChat = getNumberWithIsraelAreaCode(idToNewChat)
                if (idToNewChat[0] !== '+' || !(/^\d+$/.test(idToNewChat.replace('+', '')))) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Please enter a valid phone number'), 'sm') //alert('נא להזין מספר טלפון תקין')
                }

            }
            else if (this.state.NewConvSelectedChannel === 'mail') {
                const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                let isEmail = pattern.test(idToNewChat)
                if (!isEmail) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Please enter a valid email address.'), 'sm')//alert('נא להזין כתובת מיייל תקינה')
                }
                this.setState({ mailTo: idToNewChat + ',', mailCc: '', mailBcc: '', mailSubject: '' })
            }
            else if (this.state.NewConvSelectedChannel === 'facebook') {
                if (this.state.NewSelectedChannelObj.pageId === 0) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Select page'), 'sm')//alert(this.props.t('Select page'))
                }
                channelId = this.state.NewSelectedChannelObj.pageId
                idToNewChat = idToNewChat.toLowerCase()
            }
            else if (this.state.NewConvSelectedChannel === 'ig_media') {
                if (this.state.NewSelectedChannelObj.instagramId === 0) {
                    return this.context.showAlert(this.props.t('error'), this.props.t('Select page'), 'sm')//alert(this.props.t('Select page'))
                }
                channelId = this.state.NewSelectedChannelObj.instagramId
                idToNewChat = idToNewChat.toLowerCase()
            }
            else {
                idToNewChat = idToNewChat.toLowerCase()
            }

            // if (idToNewChat === this.props.chatSelectedSenderName && this.state.NewConvSelectedChannel === this.props.chatSelectedChannel) return
            this.props.chatUnSelected()
            this.state.socket.emit('join', { agent: this.props.agentName, conv: idToNewChat + this.props.companyId + this.state.NewConvSelectedChannel, companyId: this.props.companyId }, (error) => {
                if (error) {
                    console.log(error)
                }
            })

            this.props.chatUnSelected()
            this.props.onSelectChat(idToNewChat, this.state.NewConvSelectedChannel, 0, 0, channelId, undefined, msgId, startTime, finishTime);
            const chat = this.props.conversations.find((conv) => {
                return conv.clientName === idToNewChat
            })

            if (!chat) {
                this.setState({ msgTextBox: '', msgTextBoxDisplay: '', isFileToSendSelected: false, fileToSend: null, phoneWindowToShow: 2, selectedChatCrmContact: null, isNewChatOpen: false });
            }
            else {
                this.setState({ msgTextBox: '', msgTextBoxDisplay: '', isFileToSendSelected: false, fileToSend: null, phoneWindowToShow: 2, selectedChatCrmContact: chat.crmId, isNewChatOpen: false });
            }


            // this.props.fetchAgents()
            // for Company Join Notification
            if (this.state.NewConvSelectedChannel === 'company') {//Send join Msg

                this.props.onSendClicked(idToNewChat, this.state.NewConvSelectedChannel, this.props.agentName + ` ${this.props.t('Created group')}`, undefined, { completed: false, isPublic: false });
            }

        }

    }

    handleEmojiSelect = (event) => {
        //  console.log(event)
        // <Emoji emoji={{ id: 'santa', skin: 3 }} size={16} />
        // console.log(this.state.msgTextBox)
        const newMsgTextBoxDisplay = this.state.msgTextBoxDisplay + ReactDOMServer.renderToString(<Emoji emoji={{ id: event.id, skin: event.skin }} size={20} />) + '<span>&#8203;</span>';
        const nowMsgTextBox = this.state.msgTextBox + event.native
        // console.log(nowMsgTextBox)
        this.setState({ msgTextBox: nowMsgTextBox, msgTextBoxDisplay: newMsgTextBoxDisplay })
    }

    handleOnAvatarClick = () => {
        this.state.inputOpenFileRef.current.click()

    }


    handleOnAvatarChange = async (event) => {
        event.preventDefault();
        var file = event.target.files[0];
        console.log(event.target.files)
        const data = new FormData();
        data.append('avatar', file);
        await this.props.uploadAvatar(data);

        let randomString = Math.random().toString(36);
        this.setState({
            inputOpenFileKey: randomString
        });
        // window.location.reload()
        this.handleOnlogoutClicked()

    }

    handleOnAttachClick = () => {
        this.state.sendFileOpenFileRef.current.click();
    }

    handleOnAttachFileChange = (event) => {
        event.stopPropagation();
        event.preventDefault();
        // console.log('files')
        // console.log(event.target.files)
        var file = event.target.files;
        let randomString = Math.random().toString(36);


        this.setState({ fileToSend: file, isFileToSendSelected: true, sendFileOpenFileKey: randomString })
        // this.props.uploadAvatar(data);
        // window.location.reload();
    }



    handleOnNewConvChannelSelected = (channel) => {
        this.setState({ NewConvSelectedChannel: channel })
    }

    handleOnNewConvChannelIdSelected = (selectedChannelObj) => {
        this.setState({ NewSelectedChannelObj: selectedChannelObj })
    }

    handleOnlogoutClicked = async () => {
        this.setState({ logOutClicked: true })
        setTimeout(this.handleLogOutAfterNewState, 0)
    }

    handleLogOutAfterNewState = async () => {
        await loginRequests.logoutReq()
        // localStorage.removeItem('token');
        // localStorage.removeItem('userId');
        // this.props.onLogout();
        // this.props.logoutCleanChats();
        // window.location.reload();
    }

    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    ///////////////////////Handle Calls///////////////////////////
    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    handleCloseCall = () => {
        if (this.state.isCallScheduledToDisconnect) {
            if (this.props.nowCall.telephone === this.state.nowCallFromDiallist.telephone) {
                this.props.dialListUpdate({
                    all: false,
                    data: [
                        {
                            _id: this.state.nowCallFromDiallist._id,
                            status: this.state.nowCallFromDiallist.status === 'bore' ? 'bore' : 'notactive'
                        }
                    ]
                });//Change to notactive   
            };
            if (this.state.dialerIntervalObj) clearInterval(this.state.dialerIntervalObj)
            if (this.props.settings.dialList.autoCloseDialistOnEndCall) {
                this.setState({
                    nowCallFromDiallist: {
                        _id: null,
                        telephone: null,
                        status: null,
                        obj: null
                    }
                    // ,dialerIntervalObj: this.props.isDialerActive ? setInterval(this.runOnDialList, this.state.dialerTimeOutTime) : undefined
                });
            }
            this.resetDialerInterval()
            this.props.CallReleasedEvent(this.props.nowCall);
            this.setState({ isCallScheduledToDisconnect: false })
        }
    }

    handleOnCallBtClicked = (event, callStatus, CallNum) => {// todo dialer fix

        if (event) {
            event.stopPropagation()
        }

        // const fixedToCallNum = CallNum //replaceAll(CallNum, /[^\d]/, '')
        // if (!phonePattern.test(fixedToCallNum)) {
        //     return alert('Please check phone number')
        // }
        // console.log('Chat:handleOnCallBtClicked: callStatus=' + callStatus + ' CallNum=' + CallNum)
        switch (callStatus) {
            case allCallStatus.DISCONNECTED://Will call to client
                if (this.state.nowCallFromDiallist && this.state.nowCallFromDiallist.telephone && !this.props.settings.calls.autoDial) {
                    this.props.makeCall(this.state.nowCallFromDiallist.telephone);
                }
                else {
                    this.props.dialListAdd([
                        {
                            telephone: CallNum
                        }
                    ])
                }
                break;
            case allCallStatus.CALLING://Will disconnect the call
                console.log(this.state.nowCallFromDiallist)
                this.props.disconnectCall(this.props.nowCall.callId)
                if (this.props.nowCall.callId2) {
                    this.props.disconnectCall(this.props.nowCall.callId2)
                }
                this.setState({ isCallScheduledToDisconnect: true })
                setTimeout(() => this.handleCloseCall(), 0)
                break;
            case allCallStatus.RINGING://Will Answer
                this.props.answerCall(this.props.nowCall.callId)
                this.setState({ isCallScheduledToDisconnect: true })
                setTimeout(() => this.handleCloseCall(), 10000)
                break;
            case allCallStatus.OUTGOINGCALL://Will disconnect the call 
                console.log(this.state.nowCallFromDiallist)
                this.props.disconnectCall(this.props.nowCall.callId)
                this.handledCallIds.delete(this.props.nowCall.callId)
                if (this.props.nowCall.callId2) {
                    this.props.disconnectCall(this.props.nowCall.callId2)
                }
                this.setState({ isCallScheduledToDisconnect: true })
                setTimeout(() => this.handleCloseCall(), 0)
                break;
            case allCallStatus.INCOMINGCALL://Will disconnect the call
                console.log(this.state.nowCallFromDiallist)
                this.props.disconnectCall(this.props.nowCall.callId)
                this.handledCallIds.delete(this.props.nowCall.callId)
                if (this.props.nowCall.callId2) {
                    this.props.disconnectCall(this.props.nowCall.callId2)
                }
                this.setState({ isCallScheduledToDisconnect: true })
                setTimeout(() => this.handleCloseCall(), 0)
                break;
            default: return;
        }
    }

    handleOnAddToDialListClicked = (CallNum) => {
        this.props.dialListAdd([
            {
                telephone: CallNum
            }
        ])
    }

    handleOnCallSelected = (id, telephone, selectedDialerCrmContact, callObj = null) => {
        if (this.state.selectMultipleBtnClicked) {
            this.props.multiSelectUnselectCalls(id)
        }
        else {
            this.setState({
                settingsSelected: 5,
                selectedDialerCrmContact: selectedDialerCrmContact,
                callSelected: {
                    _id: id,
                    telephone: telephone,
                    callObj
                }
            });
        }
    };

    handleOnDialItemSelected = (id, telephone, startTime, selectedDialListCrmContact, dialListObj = null) => {
        if (this.state.selectMultipleBtnClicked) {
            this.props.multiSelectUnselectDialList(id)
        }
        else {
            this.setState({
                settingsSelected: 6,
                actionIdSelected: 1,
                selectedDialListCrmContact: selectedDialListCrmContact,
                dialItemSelected: {
                    _id: id,
                    telephone: telephone,
                    startTime: startTime,
                    dialListObj
                }
            });
        }
    };

    handleOnSingleDialListItemSelected = (dialListObj) => {
        this.setState({
            selectedDialListCrmContact: dialListObj.crmId,
            dialItemSelected: {
                _id: dialListObj._id,
                telephone: dialListObj.telephone,
                startTime: dialListObj.startTime,
                dialListObj: dialListObj
            }
        });
    }

    handleOnDialListActionSelected = async (actionId, reason, note, priority) => {
        this.setState({ actionIdSelected: actionId })
        switch (actionId) {
            case 0:
            case 1://delete one dialItem
                if (!this.state.selectMultipleBtnClicked) {
                    if (actionId === 0 && this.props.settings?.dialList?.onbmcCloseGetUrl && this.state.dialItemSelected?.dialListObj?.externalId) {// todo clubhotel
                        callbacksReq.finishClubCallBack(this.props.settings.dialList.onbmcCloseGetUrl, this.state.dialItemSelected.dialListObj.externalId, reason, note)
                    }
                    if (actionId === 1 && this.props.settings?.dialList?.onDeleteCallGetUrl && this.state.dialItemSelected?.dialListObj?.externalId) {
                        callbacksReq.deleteClubCallBack(this.props.settings.dialList.onDeleteCallGetUrl, this.state.dialItemSelected.dialListObj.externalId)
                    }
                    this.props.dialListDelete({
                        all: false,
                        data: [{
                            _id: this.state.dialItemSelected._id
                        }]
                    });
                    if (this.state.nowCallFromDiallist?._id === this.state.dialItemSelected._id) {
                        this.setState({ nowCallFromDiallist: {} })
                    }
                }
                else {
                    this.props.dialList.forEach(dialItem => {
                        if (dialItem.isDialItemMultiSelected) {
                            if (actionId === 0 && this.props.settings?.dialList?.onbmcCloseGetUrl && dialItem.externalId) {
                                callbacksReq.finishClubCallBack(this.props.settings.dialList.onbmcCloseGetUrl, dialItem.externalId, reason, note)
                            }
                            if (actionId === 1 && this.props.settings?.dialList?.onDeleteCallGetUrl && dialItem.externalId) {
                                callbacksReq.deleteClubCallBack(this.props.settings.dialList.onDeleteCallGetUrl, dialItem.externalId)
                            }
                            if (this.state.nowCallFromDiallist?._id === dialItem._id) {
                                this.setState({ nowCallFromDiallist: {} })
                            }
                            this.props.dialListDelete({
                                all: false,
                                data: [{
                                    _id: dialItem._id
                                }]
                            });
                        }
                    })

                }
                this.setState({ settingsSelected: 6, dialItemSelected: { _id: null, telephone: null, status: null, dialListObj: null } });
                break;
            case 2://delete dialList
                this.props.dialListDelete({
                    all: true
                });
                this.setState({ settingsSelected: 6, dialItemSelected: { _id: null, telephone: null, status: null, dialListObj: null } })
                break;
            case 3://change to notactive
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.dialListUpdate({
                        all: false,
                        data: [{
                            _id: this.state.dialItemSelected._id,
                            status: 'notactive'
                        }]
                    });
                }
                else {
                    this.props.dialList.forEach(dialItem => {
                        if (dialItem.isDialItemMultiSelected) {
                            this.props.dialListUpdate({
                                all: false,
                                data: [{
                                    _id: dialItem._id,
                                    status: 'notactive'
                                }]
                            });
                        }
                    })

                }
                this.setState({ settingsSelected: 6 })
                break;
            case 4://change postponed time
                this.setState({ settingsSelected: 6 })
                break;
            case 5://change time to now
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.dialListUpdate({
                        all: false,
                        data: [{
                            _id: this.state.dialItemSelected._id,
                            startTime: new Date(),
                            status: 'waiting'
                        }]
                    });
                }
                else {

                    this.props.dialList.forEach(dialItem => {
                        if (dialItem.isDialItemMultiSelected) {
                            this.props.dialListUpdate({
                                all: false,
                                data: [{
                                    _id: dialItem._id,
                                    startTime: new Date(),
                                    status: 'waiting'
                                }]
                            });
                        }
                    })
                }
                this.setState({ settingsSelected: 6 })
                break;
            case 6://source
                // if (!this.state.selectedDialListCrmContact) {//open new contact
                //     if (this.state.dialItemSelected.telephone !== undefined && this.state.dialItemSelected.telephone !== null) {
                //         window.open(this.props.urlOnNewContact.replace('[Phone]', this.state.dialItemSelected.telephone), "_blank") //to open new page
                //     }
                // }
                // else {
                //     window.open(this.state.selectedDialListCrmContact.siteUrl, "_blank") //to open new page
                // }
                this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, this.state.selectedDialListCrmContact, this.props.urlOnNewContact, this.state.dialItemSelected.telephone, true)
                this.setState({ settingsSelected: 6 })
                break;
            case 7://bore
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.dialListUpdate({
                        all: false,
                        data: [{
                            _id: this.state.dialItemSelected._id,
                            status: 'bore'
                        }]
                    });
                }
                else {
                    this.props.dialList.forEach(dialItem => {
                        if (dialItem.isDialItemMultiSelected) {
                            this.props.dialListUpdate({
                                all: false,
                                data: [{
                                    _id: dialItem._id,
                                    status: 'bore'
                                }]
                            });
                        }
                    })
                }
                this.setState({ settingsSelected: 6 })
                break;
            case 8://Update dialist crm data record
                if (!this.state.selectMultipleBtnClicked) {
                    dialerReq.fetchDialListUpdatedCrmData(this.state.dialItemSelected._id)

                }
                else {
                    for (let dialItem of this.props.dialList) {
                        if (dialItem.isDialItemMultiSelected) {
                            dialerReq.fetchDialListUpdatedCrmData(dialItem._id)
                            await delayNow(delayTimeInMlSec)
                        }
                    }
                }
                this.setState({ settingsSelected: 6 })
                break;
            default: return null
        }
    }
    // callSelected
    handleOnCallActionSelected = async (actionId) => {
        this.setState({ actionIdSelected: actionId })
        switch (actionId) {
            case 1://delete one call item
                if (!this.state.selectMultipleBtnClicked) {
                    this.props.callDelete(this.state.callSelected._id, false)

                }
                else {
                    this.props.calls.forEach(call => {
                        if (call.isCallMultiSelected) {
                            this.props.callDelete(call._id, false)
                        }
                    })
                }
                this.setState({ settingsSelected: 5, callSelected: { _id: null, telephone: null, callObj: null } });
                break;
            case 2://delete all calls
                this.props.callDelete(null, true)
                this.setState({ settingsSelected: 5, callSelected: { _id: null, telephone: null } })
                break;
            case 3://source
                // if (!this.state.selectedDialerCrmContact) {//open new contact
                //     if (this.state.callSelected.telephone !== undefined && this.state.callSelected.telephone !== null) {
                //         window.open(this.props.urlOnNewContact.replace('[Phone]', this.state.callSelected.telephone), "_blank") //to open new page
                //     }
                // }
                // else {
                //     window.open(this.state.selectedDialerCrmContact.siteUrl, "_blank") //to open new page
                // }
                this.openContactCrmWindow(this.props.companyDetails.crmOnOpenContactWindowSendApiReq, this.state.selectedDialerCrmContact, this.props.urlOnNewContact, this.state.callSelected.telephone, true)
                this.setState({ settingsSelected: 5 })
                break;
            case 4:
                if (!this.state.selectMultipleBtnClicked) {
                    callReq.fetchCallUpdatedCrmData(this.state.callSelected._id)
                }
                else {
                    for (let call of this.props.calls) {
                        if (call.isCallMultiSelected) {
                            callReq.fetchCallUpdatedCrmData(call._id)
                            await delayNow(delayTimeInMlSec)
                        }
                    }

                }
                this.setState({ settingsSelected: 5 })
                break;
            default: return null
        }
    }

    handleOnSelectPostponedTime = (date, reason, note, priority, targetAgentName) => {// todo clubhotel
        const formatedDate = new Date(date)
        if (!this.state.selectMultipleBtnClicked) {
            if (this.props.settings?.dialList?.onRejectCallGetUrl && this.state.dialItemSelected?.dialListObj?.externalId) {
                callbacksReq.rejectClubCallBack(this.props.settings.dialList.onRejectCallGetUrl, this.state.dialItemSelected.dialListObj.externalId, formatedDate, reason, note, priority)
            }
            if (this.props.settings?.dialList?.useExternalCallBackQueue && this.state.dialItemSelected?.dialListObj?.externalId) {
                this.props.dialListDelete({
                    all: false,
                    data: [{
                        _id: this.state.dialItemSelected._id
                    }]
                });
            }
            else {
                const updateData = {
                    _id: this.state.dialItemSelected._id,
                    startTime: formatedDate,
                    status: 'postponed'
                }
                if (targetAgentName) updateData.targetAgentName = targetAgentName
                this.props.dialListUpdate({
                    all: false,
                    data: [updateData]
                });
            }
            if (this.state.nowCallFromDiallist?._id === this.state.dialItemSelected._id) {
                this.setState({ nowCallFromDiallist: {} })
            }
        }
        else {
            this.props.dialList.forEach(dialItem => {
                if (dialItem.isDialItemMultiSelected) {
                    if (this.props.settings?.dialList?.onRejectCallGetUrl && dialItem.externalId) {
                        callbacksReq.rejectClubCallBack(this.props.settings.dialList.onRejectCallGetUrl, dialItem.externalId, formatedDate, reason, note, priority)
                    }
                    if (this.state.nowCallFromDiallist?._id === dialItem._id) {
                        this.setState({ nowCallFromDiallist: {} })
                    }
                    if (this.props.settings?.dialList?.useExternalCallBackQueue && dialItem.externalId) {
                        this.props.dialListDelete({
                            all: false,
                            data: [{
                                _id: dialItem._id
                            }]
                        });
                    }
                    else {
                        const updateData = {
                            _id: dialItem._id,
                            startTime: formatedDate,
                            status: 'postponed'
                        }
                        if (targetAgentName) updateData.targetAgentName = targetAgentName
                        this.props.dialListUpdate({
                            all: false,
                            data: [updateData]
                        });
                    }
                }
            })
        }
        if (targetAgentName) {
            this.setState({ settingsSelected: 6, dialItemSelected: { _id: null, telephone: null, status: null, dialListObj: null } })
        } else {
            this.setState({ settingsSelected: 6 })
        }
    }

    handleOnExitDialerClicked = () => {
        if (!this.props.nowCall) {
            if (this.state.nowCallFromDiallist && this.state.nowCallFromDiallist._id && !this.props.settings.calls.autoDial) {
                this.props.dialListUpdate({
                    all: false,
                    data: [
                        {
                            _id: this.state.nowCallFromDiallist._id,
                            status: 'notactive'
                        }
                    ]
                })
                this.setState(
                    {
                        isDialerOpen: false,
                        nowCallFromDiallist: {
                            _id: null,
                            telephone: null,
                            status: null
                        }
                    }
                )
            }
            else {
                this.setState({ isDialerOpen: false });
            }
        }
    }

    handleOnExitNewChatClicked = () => {
        this.setState({ isNewChatOpen: false });
    }

    handleOnContactTabClicked = (tabName) => {
        switch (tabName) {
            case 'Chat'://chat settings
                this.setState({ settingsSelected: 4, actionIdSelected: 0 })
                break;
            case 'Dialer'://Dialer settings    
                this.setState({ settingsSelected: 5, actionIdSelected: 0 })
                break;
            case 'DialList'://DialList settings
                this.setState({ settingsSelected: 6, actionIdSelected: 0 })
                break;
            case 'ContactList'://Contact settings
                this.setState({ settingsSelected: 7, actionIdSelected: 0 })
                break;
            case 'CRM'://CRM settings
                this.setState({ settingsSelected: 8, actionIdSelected: 0 })
                break;
            default: return null
        }
    }

    onBmcFinishClickedHandler = (reason, note, priority) => {//todo clubhotel
        if (this.state.nowCallFromDiallist) {
            if (this.props.settings?.dialList?.onbmcCloseGetUrl && this.state.nowCallFromDiallist?.obj?.externalId) {
                callbacksReq.finishClubCallBack(this.props.settings.dialList.onbmcCloseGetUrl, this.state.nowCallFromDiallist.obj.externalId, reason, note)
            }
            this.props.dialListDelete({
                all: false,
                data: [{
                    _id: this.state.nowCallFromDiallist._id
                }]
            });

            this.setState({ nowCallFromDiallist: {} })
            if (this.props.nowCall?.callId) this.props.disconnectCall(this.props.nowCall.callId)
        }
    }


    handleOnInCallPostponedClickedAndClosed = (date, telephone, callId, reason, note, priority) => {// todo clubhotel
        const newDate = new Date(date)
        if (this.props.settings.dialList.autoCloseDialistOnEndCall) {
            if (this.state.nowCallFromDiallist.telephone === telephone) {
                if (this.props.nowCall?.ansTime !== undefined && this.props.nowCall?.ansTime !== null) {
                    this.props.dialListAdd([
                        {
                            telephone: telephone,
                            startTime: newDate
                        }
                    ])
                }
                else {
                    this.props.dialListDelete({
                        all: false,
                        data: [{
                            _id: this.state.nowCallFromDiallist._id
                        }]
                    });
                    this.props.dialListAdd([
                        {
                            telephone: telephone,
                            startTime: newDate
                        }
                    ])
                }


            }
            else {
                this.props.dialListAdd([
                    {
                        telephone: telephone,
                        startTime: newDate
                    }
                ])
            }

        }
        else if (this.state.nowCallFromDiallist) {
            if (this.props.settings?.dialList?.onRejectCallGetUrl && this.state.nowCallFromDiallist?.obj?.externalId) {
                callbacksReq.rejectClubCallBack(this.props.settings.dialList.onRejectCallGetUrl, this.state.nowCallFromDiallist.obj.externalId, newDate, reason, note, priority)
            }
            if (this.props.settings?.dialList?.useExternalCallBackQueue && this.state.nowCallFromDiallist?.obj?.externalId) {
                this.props.dialListDelete({
                    all: false,
                    data: [{
                        _id: this.state.nowCallFromDiallist._id
                    }]
                });
            }
            else {
                this.props.dialListUpdate({
                    all: false,
                    data: [{
                        _id: this.state.nowCallFromDiallist._id,
                        startTime: newDate,
                        status: 'postponed'
                    }]
                });
            }

        }
        this.setState({ nowCallFromDiallist: {} })
        if (callId) {
            if (this.props.nowCall.callId !== callId) return
            this.props.disconnectCall(callId)
        }
    }
    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    ///////////////////////NotificationSystem/////////////////////
    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    showNotification = (channel, telephoneOrId, body, date, clientName = null) => {
        if (this.state.NotificationSystem.ignore) {
            return;
        }
        // if (isMobile) {//not support mobile
        //     return;
        // }

        let showIcon = undefined
        let dataToCheck = undefined
        if (channel === 'whatsapp') {
            showIcon = whatsapp
            dataToCheck = 'openChat,' + channel + ',+972' + telephoneOrId.slice(1, telephoneOrId.length)
        }
        else if (channel === 'sms') {
            showIcon = sms
            dataToCheck = 'openChat,' + channel + ',+972' + telephoneOrId.slice(1, telephoneOrId.length)
        }
        else if (channel === 'messenger') {
            showIcon = messenger
            dataToCheck = 'openChat,' + channel + ',' + telephoneOrId
        }
        else if (channel === 'instagram') {
            showIcon = instagram
            dataToCheck = 'openChat,' + channel + ',' + telephoneOrId
        }
        else if (channel === 'mail') {
            showIcon = mail
            dataToCheck = 'openChat,' + channel + ',' + telephoneOrId
        }
        else if (channel === 'company') {
            showIcon = companyIcon
            dataToCheck = 'openChat,' + channel + ',' + telephoneOrId
        }
        else if (channel === 'call') {
            showIcon = IncomingCall
            dataToCheck = 'answerCall'

        }
        // else if (channel === 'forwardIcon'){//forwardIcon
        //     showIcon = forwardIcon
        //     dataToCheck = 'forward'
        // }

        if (body === this.props.t('Chat forwarding')) {//forwardIcon
            showIcon = forwardIcon
        }
        //Available options https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
        const options = {
            tag: date,
            body: `${this.props.t('Channel')}: ` + this.getChannelNameInHeb(channel) + ' , ' + body,
            icon: showIcon,
            lang: 'he',
            dir: 'rtl',
            data: dataToCheck,
            image: notificationImage,
            // icon:'https://www.bravofurniture.net/images/catalog_icons/27.jpg'
            //  sound: {notificationSoundmp3}  // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
        }
        this.setState({
            NotificationSystem:
            {
                title: telephoneOrId + ' , ' + clientName,
                options: options
            }
        });
    }

    handlePermissionGranted = () => {
        this.setState({
            NotificationSystem:
            {
                ignore: false
            }
        });
    }
    handlePermissionDenied = () => {
        alert(this.props.t("To receive notifications, click on 'Allow Notifications'."));
        this.setState({
            NotificationSystem:
            {
                ignore: true
            }
        });
    }
    handleNotSupported = () => {
        alert("Your browser does not support notifications. To receive notifications, please open the website in a different browser.");
        this.setState({
            NotificationSystem:
            {
                ignore: true
            }
        });
    }

    handleNotificationOnClick = (e, tag) => {
        console.log('event=')
        console.log(e)
        const argsArr = e.currentTarget.data.split(',') //[type,channel,clientName]
        if (argsArr[0] === 'openChat') {
            this.handleContactChatSelected(argsArr[2], argsArr[1], 1, undefined, true, undefined)
        }
        else if (argsArr[0] === 'answerCall') {
            if (this.props.nowCall !== null && this.props.nowCall !== undefined) this.props.answerCall(this.props.nowCall.callId);
        }


    }

    handleNotificationOnShow = (e, tag) => {
        this.playSound();
        // console.log(e, 'Notification shown tag:' + tag);
    }

    playSound = () => {
        document.getElementById('sound').play();
    }

    onKeyBoardClick = (event, inputName, opt) => {
        // console.log(event.keyCode)
        if (inputName === 'mainTextInput') {
            if ((event.keyCode === 13 && event.ctrlKey)) {
                const copyMsgTextBox = this.state.msgTextBox + '\n'
                const msgTextBoxDisplay = this.state.msgTextBoxDisplay + '<br><br>'
                this.setState({ msgTextBox: copyMsgTextBox, msgTextBoxDisplay: msgTextBoxDisplay })
            }
            else if (event.keyCode === 13) {
                event.preventDefault();
                this.handleSendClicked()
            }
        }
        else if (inputName === 'searchInput') {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.handleSearchSendClicked()
            }
        }
        else if (inputName === 'newChatBtnClicked') {
            if (event.keyCode === 13) {
                this.handleOnNewConvClicked()
            }
        }
        else if (inputName === 'newCallBtnClicked') {
            if (event.keyCode === 13) {
                this.handleOnCallBtClicked(undefined, opt.callStatus, opt.phoneInput)
            }
        }
    }


    handleOnMailSubjectChanged = (event) => {
        event.preventDefault();
        this.setState({ mailSubject: event.target.value });
    }

    handleOnMailToChanged = (event, defaultToSend) => {
        event.preventDefault();
        this.setState({ mailTo: event.target.value });
    }

    handleOnMailCcChanged = (event) => {
        event.preventDefault();
        this.setState({ mailCc: event.target.value });
    }

    handleOnMailBccChanged = (event) => {
        event.preventDefault();
        this.setState({ mailBcc: event.target.value });
    }

    //@@@@@@@@@@agentWindow@@@@@@@@@@
    checkAgentWindowStatus = async () => {
        // console.log('checkAgentWindowStatus')
        if (!this.props.device) return
        let agentWindowStateData = {}
        let breakReasonsData = []
        try {
            agentWindowStateData = await agentWindowReq.getAgentWindowState()
        } catch (e) { console.log('getAgentWindowState :: Fail to fetch agent window') }
        try {
            breakReasonsData = await agentWindowReq.getBreakReasons()
        } catch (e) { console.log('getBreakReasons :: Fail to fetch breaks') }

        this.props.fetchAgentWindow(agentWindowStateData, breakReasonsData)
        setTimeout(() => {
            if (this.props.breakName && !this.state.agentBreakTimer) {
                this.setState({ agentBreakTimer: setInterval(() => this.props.incBreakSec(incBreakSecInterval), incBreakSecInterval) })
            }
        }, 3000);
    }

    refreshMediaToken = async () => {
        try {
            const mediaTokenData = await filesReq.refreshMediaToken()
            this.props.refreshMediaToken(mediaTokenData)
        } catch (e) {
            console.log(e.message)
        }
    }

    //state = ['stop','start']
    handleOnBreakStateBtnClicked = async (state, breakReason) => {
        if (state === 'start') {
            if (this.state.agentBreakTimer) clearInterval(this.state.agentBreakTimer)
            agentWindowReq.startBreak(breakReason)
            agentWindowReq.changeAcdState('Unavailable')
            this.setState({ agentBreakTimer: setInterval(() => this.props.incBreakSec(incBreakSecInterval), incBreakSecInterval) })
            if (this.props.settings?.dialList?.enableChangeGetCallBacksStateOnBreak) {
                this.props.changeAgentDialerState({ isDialerActive: false })
            }
        }
        else if (state === 'stop') {
            if (this.state.agentBreakTimer) clearInterval(this.state.agentBreakTimer)
            agentWindowReq.stopBreak()
            agentWindowReq.changeAcdState('Available')
            this.setState({ agentBreakTimer: undefined })
            if (this.props.settings?.dialList?.enableChangeGetCallBacksStateOnBreak) {
                this.props.changeAgentDialerState({ isDialerActive: true })
            }
        }
        else {
            console.log('wrong state=' + state)
        }
    }
    //acdState = ['Sign-Out','Unavailable','Available','Sign-In']
    handleOnAcdBtnClicked = async (acdState) => {
        agentWindowReq.changeAcdState(acdState)
    }

    handleOndialerStateBtnClicked = () => {

    }


    handleOnChangeAgentDialerState = () => {
        const newIsDialerActive = !this.props.isDialerActive
        if (newIsDialerActive) {
            if (!this.state.dialerIntervalObj) {
                this.setState({ dialerIntervalObj: setInterval(this.runOnDialList, this.state.dialerTimeOutTime) })
            }
        }
        else {//stop
            this.stopDialerInterval()
            //this.setState({dialerIntervalObj: setInterval(this.runOnDialList, this.state.dialerTimeOutTime)})
        }
        agentWindowReq.changeAgentDialerState()

    }

    stopDialerInterval = () => {
        if (this.state.dialerIntervalObj) {
            clearInterval(this.state.dialerIntervalObj)
            this.setState({ dialerIntervalObj: undefined })
        }
    }

    resetDialerInterval = () => {
        if (this.state.dialerIntervalObj) clearInterval(this.state.dialerIntervalObj)
        // console.log('this.props.isDialerActive=' + this.props.isDialerActive + ' this.props.isPbxConnected=' + this.props.isPbxConnected)
        if (this.props.isDialerActive && this.props.isPbxConnected) {
            this.setState({
                dialerIntervalObj: this.props.isDialerActive ? setInterval(this.runOnDialList, this.state.dialerTimeOutTime) : undefined
            })
        }
    }

    handleOnDialerReConnectBtnClicked = () => {
        agentWindowReq.dialerReConnect()
        const isPbxConnected = false
        const setPbxConnectedStatus = 'connecting'
        this.props.setPbxConnectedStatus(isPbxConnected, setPbxConnectedStatus)
    }

    //@@@@@@@@@@Settings@@@@@@@@@@
    handleOnSettingsBtnClicked = () => {
        if (!this.state.showSettingsModal) {
            this.setState({ showSettingsModal: true })
        }
        else {
            this.setState({ showSettingsModal: false })
        }
    }

    handleOnUpdateSettingsBtnClicked = () => {
        this.handleOnSettingsBtnClicked()
        settingsReq.updateSettings(this.props.settings)
        loginRequests.logoutAllAgents()
    }

    handleOnAutoSendTempMsgUpdateClicked = async (tempMsg, startTime, endTime, startDayInputState, endDayInputState, display) => {
        // console.log('handleOnAutoSendTempMsgUpdateClicked')
        // console.log('tempMsg')
        // console.log(tempMsg)
        // console.log('startTime')
        // console.log(startTime)
        // console.log('endTime')
        // console.log(endTime)
        const reqObj = {
            tempMsg,
            startTime,
            endTime,
            autoSendStartDay: startDayInputState,
            autoSendEndDay: endDayInputState,
            display: display
        }
        await tempMsgReq.updateTempMsg(reqObj)
        this.props.fetchAgentTempMsg()
    }

    handleOnTempMsgDelete = async (_id) => {
        await tempMsgReq.deleteTempMsg(_id)
        this.props.fetchAgentTempMsg()
    }

    handleOnTempMsgAdd = async (msg, display) => {
        const reqObj = {
            msg,
            display
        }
        // console.log(reqObj)
        await tempMsgReq.addTempMsg(reqObj)
        this.props.fetchAgentTempMsg()
    }

    handleOnAutoSendTempMsgDeleteClicked = async (tempMsg) => {
        // console.log('handleOnAutoSendTempMsgDeleteClicked')
        // console.log('tempMsg')
        // console.log(tempMsg)
        const reqObj = {
            tempMsg
        }
        await tempMsgReq.updateTempMsg(reqObj)
        this.props.fetchAgentTempMsg()

    }

    handleOnSelectMultipleBtnClicked = () => {
        if (this.state.selectMultipleBtnClicked) {//old state
            this.props.multiSelectUnselectAllChat('unSelectall')
            this.props.multiSelectUnselectAllCalls('unSelectall')
            this.props.multiSelectUnselectAllDialList('unSelectall')
        }
        this.setState({ selectMultipleBtnClicked: !this.state.selectMultipleBtnClicked })
    }

    //@@@@@@@@@@ContactList@@@@@@@@@@
    // mode = "add","edit"
    // whereTypped = CONTACT, CONV , DIALER ,DIALLIST
    handleOnContactListBtnClicked = (mode, whereTypped) => {
        this.setState(prevState => ({
            showContactListModal: !prevState.showContactListModal,
            contactListMode: mode,
            whereTypped: whereTypped
        }));
    };

    // toggleConfirmationModal = (show, contactId = null) => {
    //     this.setState({ showConfirmationModal: show, contactIdToDelete: contactId });
    // };


    onDeleteContactList = async (contactIdToDelete) => {
        // const { contactIdToDelete } = this.state;
        if (this.props.permissionType > 3) return
        if (contactIdToDelete) {
            try {
                await deleteContactList(contactIdToDelete);
                this.context.showAlert(this.props.t('success'), this.props.t('The record has been successfully deleted'), 'sm')
            } catch (error) {
                console.error("Error in deleting contact", error);
            }
        }
        // this.toggleConfirmationModal(false);
    };

    //   onDeleteContactList = async (selectedContactId) => {
    //     if (this.props.permissionType > 3) return
    //     if (selectedContactId) {
    //         try {
    //             await deleteContactList(selectedContactId);
    //             this.context.showAlert(this.props.t('success'), this.props.t('The record has been successfully deleted'), 'sm')
    //         } catch (error) {
    //             console.error("Error in deleting contact", error);
    //         }


    //     }
    // };

    // handleOnContactListBtnClicked = () => {
    //     if (!this.state.showContactListModal) {
    //         this.setState({ showContactListModal: true })
    //     }
    //     else {
    //         this.setState({ showContactListModal: false })
    //     }
    // }

    //@@@@@@@@@@End ContactList@@@@@@@@@@


    handleOnPageArrowClick = (type, Tab) => {// type=[inc/dec/incAll/decAll] , Tab=[chat,dialList,dialer] 
        let isPageChanged = false
        if (Tab === 'Chat') {
            isPageChanged = this.actionsOnPages(type, this.props.totalCountOfChats, this.state.selectedChatsPage, 'selectedChatsPage')
        }
        else if (Tab === 'Dialer') {
            isPageChanged = this.actionsOnPages(type, this.props.totalCountOfCalls, this.state.selectedCallsPage, 'selectedCallsPage')
        }
        else if (Tab === 'DialList') {
            isPageChanged = this.actionsOnPages(type, this.props.totalCountOfDialList, this.state.selectedDialListPage, 'selectedDialListPage')
        }
        else if (Tab === 'ContactList') {
            isPageChanged = this.actionsOnPages(type, this.props.totalCountOfContact, this.state.selectedContactPage, 'selectedContactPage')
        }
        if (!isPageChanged) return
        let toFetchGroupsList = undefined
        if (this.state.groupFilterSelected) {
            toFetchGroupsList = [this.state.groupFilterSelected]
        }
        setTimeout(() => this.activeFetchChats(this.state.chatTypeSelected, this.state.searchTextBox, this.state.selectedMsgTypesFilter, toFetchGroupsList), 0)

    }

    actionsOnPages = (type, totalCountOfElements, nowPage, nameOfPageOnState) => {
        let newPage = undefined
        if (type === 'inc') {
            newPage = nowPage + 1
            if (newPage > parseInt(totalCountOfElements / jumpItemsInPage)) return false
            this.setState({ [nameOfPageOnState]: newPage })
        }
        else if (type === 'incAll') {
            if (nowPage === parseInt(totalCountOfElements / jumpItemsInPage)) return false
            newPage = parseInt(totalCountOfElements / jumpItemsInPage)
            this.setState({ [nameOfPageOnState]: newPage })
        }
        else if (type === 'dec') {
            if (nowPage - 1 < 0) return false
            else newPage = nowPage - 1
            this.setState({ [nameOfPageOnState]: newPage })
        }
        else if (type === 'decAll') {
            if (nowPage === 0) return false
            newPage = 0
            this.setState({ [nameOfPageOnState]: newPage })
        }
        return true
    }

    handleOnFaceBookUserIdChange = (userId) => {
        this.setState({ facebook_userID: userId })
    }

    //@@@@@@@@@@msg actions@@@@@@@@@@
    handleOnMsgActionSelected = (selectedMsg, selectedMsgAction, opt) => {
        if (this.props.chatSelectedChannel === 'mail') {
            if (this.props.selectedMsg && this.props.selectedMsgAction &&
                (!selectedMsg || (this.props.selectedMsg._id === selectedMsg._id && this.props.selectedMsgAction === selectedMsgAction))
            ) {
                this.setState({ mailTo: '', mailCc: '', mailBcc: '', mailSubject: '' })
            }
            else {
                if (selectedMsgAction === 'REPLY') {
                    this.setState({ mailTo: selectedMsg.clientName + ',', mailCc: '', mailBcc: '', mailSubject: 'Re: ' + selectedMsg.msgSubject })
                }
                else if (selectedMsgAction === 'FORWARD') {
                    this.setState({ mailTo: '', mailCc: '', mailBcc: '', mailSubject: 'Fwd: ' + selectedMsg.msgSubject })
                }
                else if (selectedMsgAction === 'REPLY_ALL') {
                    let to = ''
                    let cc = ''
                    let bcc = ''
                    for (let selectedMsgTo of selectedMsg.msgMails) {
                        to += selectedMsgTo.address + ','
                    }
                    if (!to.includes(selectedMsg.clientName)) {
                        to += selectedMsg.clientName
                    }
                    for (let selectedMsgCC of selectedMsg.msgCC) {
                        cc += selectedMsgCC.address + ','
                    }
                    for (let selectedMsgBCC of selectedMsg.msgBCC) {
                        bcc += selectedMsgBCC.address + ','
                    }
                    this.setState({ mailTo: to, mailCc: cc, mailBcc: bcc, mailSubject: 'Re: ' + selectedMsg.msgSubject })
                }

            }
        }

        this.props.selectMsg(selectedMsg, selectedMsgAction, opt)
    }

    //MultipleMsgSending
    handleOnHideMultipleMsgSendingClicked = () => {
        this.setState({ showMultipleMsgSending: false })
    }

    handleOnShowMultipleMsgSendingClicked = () => {
        this.setState({ showMultipleMsgSending: true })
    }
    handleOnReloadClicked = async () => {
        if (this.props.chatSelectedChannel === 'facebook' || this.props.chatSelectedChannel === 'ig_media') {
            await facebookReq.fetch_FB_Postcomments(this.props.chatSelectedSenderName, this.props.chatSelectedChannelId, this.props.chatSelectedChannel)
        }
        this.props.onSelectChat(this.props.chatSelectedSenderName, this.props.chatSelectedChannel, 0, 0, this.props.chatSelectedChannelId, true);
    }

    //FileManeger 

    onToggleFileManagerHandler = (fileCategoryLimit) => {
        console.log('onToggleFileManagerHandler clicked')
        const fileCategoryLimitCheck = typeof fileCategoryLimit === 'string' ? fileCategoryLimit : undefined
        this.setState({ showFileManager: !this.state.showFileManager, fileCategoryLimit: fileCategoryLimitCheck })
    }

    onAttachFilesToMessageFromFileManagerClickHandler = (fileArr = []) => { //getting files after it was added to galler
        if (fileArr?.length > 0) {
            let newFileToSend = this.state.fileToSend || []
            const toConcatFiles = fileArr.filter((toAddfile) => {
                return !newFileToSend.find(alreadyExistFiles => {
                    return (
                        (toAddfile._id && (alreadyExistFiles._id === toAddfile._id)) ||
                        (toAddfile.lastModified && (alreadyExistFiles.lastModified === toAddfile.lastModified))
                    )
                })
            })
            newFileToSend = newFileToSend.concat(toConcatFiles)
            this.setState({ fileToSend: newFileToSend, isFileToSendSelected: true, showFileManager: false })
            // this.setState({ fileToSend: fileArr, isFileToSendSelected: true, showFileManager: false })
        }

    }

    onAttachFilesWithoutGalleryHandler = (fileArr = []) => {// getting  file array from fileExplorer input
        if (fileArr?.length > 0) {
            let newFileToSend = this.state.fileToSend || []
            const toConcatFiles = fileArr.filter((toAddfile) => {
                return !newFileToSend.find(alreadyExistFiles => {
                    return (
                        (toAddfile._id && (alreadyExistFiles._id === toAddfile._id)) ||
                        (toAddfile.lastModified && (alreadyExistFiles.lastModified === toAddfile.lastModified))
                    )
                })
            })
            newFileToSend = newFileToSend.concat(toConcatFiles)
            this.setState({ fileToSend: newFileToSend, isFileToSendSelected: true, showFileManager: false })
            // this.setState({ fileToSend: fileArr, isFileToSendSelected: true, showFileManager: false })
        }
    }
    //this.setState({ fileToSend: file, isFileToSendSelected: true, sendFileOpenFileKey: randomString })

    onGettingEncContainerUrlHandler = (containerUrl) => {
        const oldMsgTextBox = this.state.msgTextBox
        const placeholders = oldMsgTextBox.match(/{{\d+}}/g)

        if (!placeholders) {// If no placeholders are found
            this.setState({ msgTextBox: `${oldMsgTextBox} ${containerUrl}`, showFileManager: false })
            return
        }
        const numbers = placeholders.map(ph => parseInt(ph.match(/\d+/)[0])) // Extract the numbers from the placeholders
        const largestNumber = Math.max(...numbers) // Find the largest number
        const largestPlaceholder = `{{${largestNumber}}}`;// Create the largest placeholder string
        this.setState({ msgTextBox: oldMsgTextBox.replace(largestPlaceholder, containerUrl), showFileManager: false });
    }

    onRemoveFileFromAttachmentsClickedHandler = (id) => {
        let filesAttachment = this.state.fileToSend || []
        const toRemoveIndex = filesAttachment.findIndex((file) => {
            return file._id === id || file.lastModified === id
        })
        if (toRemoveIndex > -1) {
            filesAttachment.splice(toRemoveIndex, 1)
        }
        if (!filesAttachment.length) {
            this.setState({ isFileToSendSelected: false })
        }
        this.setState({ fileToSend: filesAttachment })
    }

    onAdditionCallDetailsModalToggleHandler = (details = { detailsType: null, telephone: null, onSave: null }) => { // todo clubhotel detailsType=['FINISH_CALL','REJECT_CALL']
        let externalId
        if (details.telephone === this.state.nowCallFromDiallist?.obj?.telephone && this.state.nowCallFromDiallist.obj.externalId) {
            externalId = this.state.nowCallFromDiallist.obj.externalId
        }
        else if (details.telephone === this.state.dialItemSelected?.dialListObj?.telephone && this.state.dialItemSelected.dialListObj.externalId) {
            externalId = this.state.dialItemSelected.dialListObj.externalId
        }

        const oldShowAdditionCallDetails = this.state.additionCallDetailsModalObj?.show
        if (oldShowAdditionCallDetails) {
            this.setState({ additionCallDetailsModalObj: { show: false } })
        }
        else if (this.props.settings.dialList.supportAdditionDialItemInfo && externalId) {

            if (details?.detailsType) {
                this.setState({ additionCallDetailsModalObj: { show: true, ...details } })
            }
        }
        else { //this.state.nowCallFromDiallist?.obj?.externalId this.state.dialItemSelected?.dialListObj?.externalId
            if (details.onSave)
                details.onSave()
        }
    }



    render() {
        return (

            <div className="container customizedContainer">

                {this.props.device ?
                    <AgentWindow
                        breakName={this.props.breakName}
                        breakDurationSec={this.props.breakDurationSec}
                        breakStartTime={this.props.breakStartTime}
                        acdState={this.props.acdState}
                        breakReasons={this.props.breakReasons}
                        OnBreakStateBtnClicked={this.handleOnBreakStateBtnClicked}
                        OnAcdBtnClicked={this.handleOnAcdBtnClicked}
                        handleOndialerStateBtnClicked={this.handleOndialerStateBtnClicked}
                        calls={this.props.calls}
                        callsCount={this.props.totalCountOfCalls}
                        todayCallsCount={this.props.todayCallCount}
                        isDialerActive={this.props.isDialerActive}
                        OnchangeAgentDialerState={this.handleOnChangeAgentDialerState}
                        PbxConnectionStatus={this.props.PbxConnectionStatus}
                        OnDialerReConnectBtnClicked={this.handleOnDialerReConnectBtnClicked}
                        device={this.props.device}
                        deviceShortNum={this.props.companyExts?.find(ext => ext.device === this.props.device)?.shortNum}
                    />
                    :
                    <br />
                }
                <div className="chatContainer">
                    <div className="row">
                        <div className={this.state.phoneWindowToShow === 3 ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2 leftChat"} >
                            <Logo changeWindowToShow={this.handleChangeWindowToShow} />
                            {/* <Categoryselect onSettingsSelect={this.handleOnSettingsSelect}
                                onLogout={this.handleOnlogoutClicked} /> */}
                            <ChatSettings
                                avatarImg={this.props.avatar}
                                companyDetails={this.props.companyDetails}
                                onContactListBtnClicked={this.handleOnContactListBtnClicked}
                                actionId={this.state.actionIdSelected}
                                chatTypeSelected={this.state.chatTypeSelected}
                                ChatActionSelected={this.handleOnChatActionSelected}
                                settingsSelected={this.state.settingsSelected}
                                permissionType={this.props.permissionType}
                                canDeleteChat={this.props.canDeleteChat}
                                categorySelected={this.handleOnCategorySelected}
                                agentsList={this.props.companyAgents}
                                agentName={this.props.agentName}
                                company_groupList={this.props.company_groupList}
                                agent_groupList={this.props.agent_groupList}
                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                agentAddToChatClicked={this.handleOnAgentAddToChatClicked}
                                OnAgentForwardClicked={this.handleOnAgentForwardClicked}
                                OnAddChatToGroupClicked={this.handleOnAddChatToGroupClicked}
                                OnRemoveChatFromGroup={this.handleOnRemoveChatFromGroup}
                                OnGroupForwardClicked={this.handleOnGroupForwardClicked}
                                selectedChannel={this.state.NewConvSelectedChannel}
                                selectedConv={this.props.selectedConv}
                                dialListActionSelected={this.handleOnDialListActionSelected}
                                OnSelectPostponedTime={this.handleOnSelectPostponedTime}
                                dialItemSelected={this.state.dialItemSelected}
                                callSelected={this.state.callSelected}
                                chatSelected={{ clientName: this.props.chatSelectedSenderName, channel: this.props.chatSelectedChannel }}
                                OnCallActionSelected={this.handleOnCallActionSelected}
                                selectedChatCrmContact={this.state.selectedChatCrmContact}
                                selectedDialerCrmContact={this.state.selectedDialerCrmContact}
                                selectedDialListCrmContact={this.state.selectedDialListCrmContact}
                                OnChatChannelFilterSelected={this.handleOnChatChannelFilterSelected}
                                OnGroupFilterSelected={this.handleOnGroupFilterSelected}
                                groupFilterSelected={this.state.groupFilterSelected}
                                chatChannelFilterSelectedState={this.state.selectedMsgTypesFilter}
                                categoryUnSeenMsgsStatus={this.props.categoryUnSeenMsgsStatus}
                                settings={this.props.settings}
                                selectMultipleBtnClicked={this.state.selectMultipleBtnClicked}
                                isFaceBookLogged={this.props.isFaceBookLogged}
                                facebook_userID={this.state.facebook_userID}
                                onFaceBookUserIdChange={this.handleOnFaceBookUserIdChange}
                                groupSetting={this.props.settings.groups}
                                device={this.props.device}
                                //Contacts
                                contacts={this.props.contacts}
                                nowSelectedContact={this.props.selectedContact}
                                onDeleteContactList={this.onDeleteContactList}
                                onContactSelect={this.handleOnContactSelect}
                                contactListMode={this.state.contactListMode}
                                onCallSelected={this.handleOnCallSelected}
                                toggleConfirmationModal={this.toggleConfirmationModal}
                                mediaTokenData={this.props.mediaTokenData}
                                onAdditionCallDetailsModalToggle={this.onAdditionCallDetailsModalToggleHandler}
                                supportedMsgTypes={this.props.supportedMsgTypes}
                                channelsettings={this.props.settings.channel}
                            />
                            <input className='fileSelector' key={this.state.inputOpenFileKey} type="file" accept=".gif,.jpg,.jpeg,.png" ref={this.state.inputOpenFileRef} onChange={this.handleOnAvatarChange} />
                            <input className='fileSelector' key={this.state.sendFileOpenFileKey} type="file" multiple="multiple" accept={sendMediaSupportedTypes[this.props.chatSelectedChannel]} ref={this.state.sendFileOpenFileRef} onChange={this.handleOnAttachFileChange} />

                        </div>
                        <div className={this.state.phoneWindowToShow === 2 ? "col-sm-12 col-md-8" : "col-sm-12 col-md-8 inChatContainerCol"}  >
                            <ConversationInfo chatSelected={this.props.chatSelectedSenderName}
                                selectedChannel={this.props.chatSelectedChannel}
                                changeWindowToShow={this.handleChangeWindowToShow}
                                selectedChatCrmContact={this.state.selectedChatCrmContact}
                                selectedConv={this.props.selectedConv}
                            />

                            <ChatMsgs
                                avatarImg={this.props.avatar}
                                msgs={this.props.msgs}
                                onFetchMoreChatMsgsClicked={this.handleOnFetchMoreChatMsgsClicked}
                                loadedMsgCount={this.props.loadedMsgCount}
                                loadedMsgFromPagingCount={this.props.loadedMsgFromPagingCount}
                                areMoreMsgToLoad={this.props.areMoreMsgToLoad}
                                loadingMsg={this.props.loadingMsg}
                                chatSelected={this.props.chatSelectedSenderName}
                                ScrollDownRef={this.handleScrollDownRef}
                                selectedChatCrmContact={this.state.selectedChatCrmContact}
                                selectedChannel={this.props.chatSelectedChannel}
                                loggedNowAgent={this.props.agentName}
                                selectedConv={this.props.selectedConv}
                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                companyAgents={this.props.companyAgents}
                                onMsgActionSelected={this.handleOnMsgActionSelected}
                                selectedMsg={this.props.selectedMsg}
                                selectedMsgAction={this.props.selectedMsgAction}
                                mediaTokenData={this.props.mediaTokenData}
                                fileToSend={this.state.fileToSend}
                                onRemoveFileFromAttachmentsClicked={this.onRemoveFileFromAttachmentsClickedHandler}
                            />
                            <TextInput
                                companyDetails={this.props.companyDetails}
                                addedChar={this.handleNewChatChar}
                                sendClicked={this.handleSendClicked}
                                value={this.state.msgTextBox}
                                msgTextBoxDisplay={this.state.msgTextBoxDisplay}
                                emojiSelect={this.handleEmojiSelect}
                                isFileToSendSelected={this.state.isFileToSendSelected}
                                onAttachClick={this.handleOnAttachClick}
                                onKeyBoardClick={this.onKeyBoardClick}
                                selectedChannel={this.props.chatSelectedChannel}
                                clientName={this.props.chatSelectedSenderName}
                                handleOnMailSubjectChanged={this.handleOnMailSubjectChanged}
                                isMailMsgActionClicked={this.props.selectedMsgAction}
                                mailSubject={this.state.mailSubject}
                                handleOnMailToChanged={this.handleOnMailToChanged}
                                handleOnMailCcChanged={this.handleOnMailCcChanged}
                                handleOnMailBccChanged={this.handleOnMailBccChanged}
                                mailTo={this.state.mailTo}
                                mailCc={this.state.mailCc}
                                mailBcc={this.state.mailBcc}
                                selectedClientName={this.props.chatSelectedSenderName}
                                tempMsgs={this.props.tempMsgs}
                                onToggleFileManager={this.onToggleFileManagerHandler}
                                onAttachFilesWithoutGallery={this.onAttachFilesWithoutGalleryHandler}
                                channelsettings={this.props.settings.channel}
                            />
                        </div>
                        <div className={this.state.phoneWindowToShow === 1 ? "col-sm-12 col-md-2" : "col-sm-12 col-md-2 rightChat"}>
                            <AgentInfo
                                agentName={this.props.agentName}
                                name={this.props.name}
                                userId={this.props.userId}
                                avatarImg={this.props.avatar}
                                changeWindowToShow={this.handleChangeWindowToShow}
                                onAvatarClick={this.handleOnAvatarClick}
                                onSettingsSelect={this.handleOnSettingsSelect}
                                onLogout={this.handleOnlogoutClicked}
                                permissionType={this.props.permissionType}
                                onSettingsBtnClicked={this.handleOnSettingsBtnClicked}
                                onContactListBtnClicked={this.handleOnContactListBtnClicked}
                                biUrl={this.props.biUrl}
                                device={this.props.device}
                                onShowMultipleMsgSendingClicked={this.handleOnShowMultipleMsgSendingClicked}
                                fetchFacebookFeedPosts={this.fetchFacebookFeedPosts}
                                companyDetails={this.props.companyDetails}
                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                companyAgents={this.props.companyAgents}
                                onChatNotificationClicked={this.onSelectConv}
                                onFaceBookUserIdChange={this.handleOnFaceBookUserIdChange}
                                facebook_userID={this.state.facebook_userID}
                                settings={this.props.settings}
                            />
                            {/* <ChatProperties permissionType={this.props.permissionType} categorySelected={this.handleOnCategorySelected} /> */}
                            <ChatContacts
                                companyDetails={this.props.companyDetails}
                                SearchSendClicked={this.handleSearchSendClicked}
                                value={this.state.searchTextBox} OnSearchchar={this.handleOnSearchchar}
                                conversations={this.props.conversations}
                                loadingChat={this.props.loadingChat}
                                chatSelected={this.handleContactChatSelected}
                                nowChatSelected={this.props.chatSelectedSenderName}
                                nowSelectedChannel={this.props.chatSelectedChannel}
                                CallBtClicked={this.handleOnCallBtClicked}
                                OnAddToDialListClicked={this.handleOnAddToDialListClicked}
                                calls={this.props.calls}
                                nowCall={this.props.nowCall}
                                nowCallFromDiallist={this.state.nowCallFromDiallist}
                                dialList={this.props.dialList}
                                callSelected={this.state.callSelected}
                                onCallSelected={this.handleOnCallSelected}
                                dialItemSelected={this.state.dialItemSelected}
                                OnDialItemSelected={this.handleOnDialItemSelected}
                                isDialerOpen={this.state.isDialerOpen}
                                onExitDialerClicked={this.handleOnExitDialerClicked}
                                isNewChatOpen={this.state.isNewChatOpen}
                                onExitNewChatClicked={this.handleOnExitNewChatClicked}
                                selectMultipleBtnClicked={this.state.selectMultipleBtnClicked}
                                OnSelectMultipleBtnClicked={this.handleOnSelectMultipleBtnClicked}
                                multiSelectCount={this.props.multiSelectCount}
                                OnSelectAllClicked={this.handleOnSelectAllClicked}
                                multiSelectCallsCount={this.props.multiSelectCallsCount}
                                OnSelectAllCallsClicked={this.handleOnSelectAllCallsClicked}
                                multiSelectdialListCount={this.props.multiSelectdialListCount}
                                OnSelectAllDialListClicked={this.handleOnSelectAllDialListClicked}
                                ////////////// 
                                OnNewConvChannelSelected={this.handleOnNewConvChannelSelected}
                                newCharOnConvName={this.handleNewCharOnConvName}
                                onNewConvName={this.handleOnNewConvName}
                                NewConvNameTextBoxValue={this.NewConvNameTextBox}
                                OnNewConvClicked={() => this.handleOnNewConvClicked()}
                                selectedChannel={this.state.NewConvSelectedChannel}
                                ///////////////
                                OnContactTabClicked={this.handleOnContactTabClicked}
                                dialListUpdate={this.props.dialListUpdate}
                                OnInCallPostponedClickedAndClosed={this.handleOnInCallPostponedClickedAndClosed}
                                onBmcFinishClicked={this.onBmcFinishClickedHandler}
                                onAdditionCallDetailsModalToggle={this.onAdditionCallDetailsModalToggleHandler}
                                loggedNowAgent={this.props.agentName}
                                //////////////
                                onKeyBoardClick={this.onKeyBoardClick}
                                /////////////
                                selectedChatsPage={this.state.selectedChatsPage}
                                totalNumOfChatPages={parseInt(this.props.totalCountOfChats / jumpItemsInPage)}
                                selectedDialListPage={this.state.selectedDialListPage}
                                totalCountOfDialList={parseInt(this.props.totalCountOfDialList / jumpItemsInPage)}
                                selectedCallsPage={this.state.selectedCallsPage}
                                totalCountOfCalls={parseInt(this.props.totalCountOfCalls / jumpItemsInPage)}
                                onPageArrowClick={this.handleOnPageArrowClick}
                                //
                                companyExts={this.props.companyExts}
                                callConfStart={this.props.callConfStart}
                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                //
                                device={this.props.device}
                                facebook_pageAccess={this.props.facebook_pageAccess}
                                onNewConvChannelIdSelected={this.handleOnNewConvChannelIdSelected}
                                NewSelectedChannelObj={this.state.NewSelectedChannelObj}
                                //
                                onOpenContactCrmWindowClicked={this.openContactCrmWindow.bind(this)}
                                //Contacts
                                contacts={this.props.contacts}
                                onContactSelect={this.handleOnContactSelect}
                                nowSelectedContact={this.props.selectedContact}
                                selectedContactPage={this.state.selectedContactPage}
                                totalCountOfContactPage={parseInt(this.props.totalCountOfContact / jumpItemsInPage)}
                                onContactListBtnClicked={this.handleOnContactListBtnClicked}
                                //pbx
                                pbxType={this.props.pbxType}
                                //crm
                                permissionType={this.props.permissionType}
                                groupSetting={this.props.settings.groups}
                            />
                            <Notification
                                ignore={this.state.NotificationSystem.ignore && this.state.NotificationSystem.title !== ''}
                                notSupported={() => this.handleNotSupported()}
                                onPermissionGranted={() => this.handlePermissionGranted()}
                                onPermissionDenied={() => this.handlePermissionDenied()}
                                onShow={(e, tag) => this.handleNotificationOnShow(e, tag)}
                                onClick={(e, tag) => this.handleNotificationOnClick(e, tag)}
                                // onClose={(e, tag) => this.handleNotificationOnClose(e, tag)}
                                // onError={(e, tag) => this.handleNotificationOnError(e, tag)}
                                timeout={this.state.NotificationSystem.timeout}
                                title={!this.state.NotificationSystem.title ? '' : this.state.NotificationSystem.title}
                                options={this.state.NotificationSystem.options}
                            // swRegistration={this.props.swRegistration}
                            />
                            <audio id='sound' preload='auto'>
                                <source src={notificationSoundmp3} type='audio/mpeg' />
                                <source src={notificationSoundogg} type='audio/ogg' />
                                <embed hidden={true} autostart='false' loop={false} src={notificationSoundmp3} />
                            </audio>
                            <CompanySettings
                                companyDetails={this.props.companyDetails}
                                show={this.state.showSettingsModal}
                                onHide={this.handleOnSettingsBtnClicked}
                                channelsettings={this.props.settings.channel}
                                callssetting={this.props.settings.calls}
                                callBackSetting={this.props.settings.callBack}
                                groupSetting={this.props.settings.groups}
                                sourceSettings={this.props.settings.source}
                                botSettings={this.props.settings.bot}
                                generalSettings={this.props.settings.general}
                                dialListSettings={this.props.settings.dialList}
                                setsettings={this.props.setSettings}
                                onUpdateSettingsBtnClicked={this.handleOnUpdateSettingsBtnClicked}
                                tempmsgs={this.props.tempMsgs}
                                agentsList={this.props.companyAgents}
                                onAutoSendTempMsgUpdateClicked={this.handleOnAutoSendTempMsgUpdateClicked}
                                onAutoSendTempMsgDeleteClicked={this.handleOnAutoSendTempMsgDeleteClicked}
                                onTempMsgAdd={this.handleOnTempMsgAdd}
                                onTempMsgDelete={this.handleOnTempMsgDelete}
                                permissionType={this.props.permissionType}
                                company_groupList={this.props.company_groupList}
                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                avatarImg={this.props.avatar}
                            />
                            <OpenContactModal show={this.state.showContactListModal} onHide={this.handleOnContactListBtnClicked} settingsSelected={this.state.settingsSelected}
                                contacts={this.props.contacts}
                                onContactSelect={this.handleOnContactSelect}
                                nowSelectedContact={this.props.selectedContact} contactListMode={this.state.contactListMode}
                                selectedChannel={this.props.chatSelectedChannel} selectedConv={this.props.selectedConv} whereTypped={this.state.whereTypped}
                                callSelected={this.state.callSelected}
                                dialItemSelected={this.state.dialItemSelected}

                                OnNewConvChannelSelected={this.handleOnNewConvChannelSelected}
                                OnNewConvClicked={() => this.handleOnNewConvClicked()}
                                onNewConvName={this.handleOnNewConvName}
                                onContactListBtnClicked={this.handleOnContactListBtnClicked}

                                OnContactTabClicked={this.handleOnContactTabClicked}
                                openNewApiConvByMsgTypeAndClientName={this.openNewApiConvByMsgTypeAndClientName}

                                agentsList={this.props.companyAgents}

                            />
                            {this.state.showFileManager &&
                                <FileManager
                                    onHide={this.onToggleFileManagerHandler}
                                    mediaTokenData={this.props.mediaTokenData}
                                    permissionType={this.props.permissionType}
                                    onAttachFilesClicked={this.onAttachFilesToMessageFromFileManagerClickHandler}
                                    onAttachFilesWithoutGalleryClicked={this.onAttachFilesWithoutGalleryHandler}
                                    clientName={this.props.selectedConv?.clientName}
                                    msgType={this.props.selectedConv?.msgType}
                                    selectedConv={this.props.selectedConv}
                                    onGettingEncContainerUrl={this.onGettingEncContainerUrlHandler}
                                    settings={this.props.settings}
                                    fileTypesLimit={sendMediaSupportedTypes[this.props.chatSelectedChannel]}
                                    fileCategoryLimit={this.state.fileCategoryLimit}
                                />
                            }
                            {
                                this.props.crmPath.crm === 'crm' &&
                                <CrmModal
                                    onSelectConv={this.onSelectConv}
                                    OnAddToDialListClicked={this.handleOnAddToDialListClicked}
                                />
                            }
                            <MultipleMsgSending
                                show={this.state.showMultipleMsgSending}
                                onHide={this.handleOnHideMultipleMsgSendingClicked}
                                tempMsgs={this.props.tempMsgs}
                                onSendClicked={this.props.onSendClicked}
                                attachToBeginMsg={this.props.settings.channel.attachToBeginMsg}
                                loggedAgentName={this.props.name}
                                mediaTokenData={this.props.mediaTokenData}
                                permissionType={this.props.permissionType}
                                settings={this.props.settings}
                            />
                            <Modal
                                show={this.state.modal.show}
                                modalTitle={this.state.modal.modalTitle}
                                modalBody={this.state.modal.modalBody}
                                btnList={this.state.modal.btnList}
                                onHide={this.state.modal.onHide}
                            />
                            <AdditionCallDetailsModal
                                telephone={this.state.additionCallDetailsModalObj?.telephone}
                                onSave={this.state.additionCallDetailsModalObj.onSave}
                                onHide={this.onAdditionCallDetailsModalToggleHandler}
                                show={this.state.additionCallDetailsModalObj?.show}
                                callBackSetting={this.props.settings.callBack}
                            />
                            {/* <ConfirmationModal
                                show={this.state.showConfirmationModal}
                                onHide={() => this.toggleConfirmationModal(false)}
                                onConfirm={this.onDeleteContactList}
                            /> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        isLogged: state.login.token !== null,
        permissionType: state.login.permissionType,
        canDeleteChat: state.login.canDeleteChat,
        agentName: state.login.agentName,
        name: state.login.name,
        tokenExpiresInMin: state.login.tokenExpiresInMin,
        userId: state.login.userId,
        pbxType: state.login.companyDetails?.pbxType,
        mediaTokenData: state.login.mediaTokenData,
        lastReadChangeLogTime: state.login.lastReadChangeLogTime,
        companyId: state.login.companyId,
        avatar: state.login.avatar,
        agent_groupList: state.login.agent_groupList,
        company_groupList: state.login.company_groupList,
        urlOnNewContact: state.login.urlOnNewContact,
        companyAgents: state.login.companyAgents,
        listOfOnlineAgents: state.login.listOfOnlineAgents,
        companyExts: state.login.companyExts,
        tempMsgs: state.login.tempMsgs,
        isFaceBookLogged: state.login.isFaceBookLogged,
        msgs: state.msgs.msgs,
        loadedMsgCount: state.msgs.loadedMsgCount,
        loadedMsgFromPagingCount: state.msgs.loadedMsgFromPagingCount,
        areMoreMsgToLoad: state.msgs.areMoreMsgToLoad,
        conversations: state.msgs.conversations,
        totalCountOfChats: state.msgs.totalCountOfChats,
        totalCountOfCalls: state.dialer.totalCountOfCalls,
        todayCallCount: state.dialer.todayCallCount,
        totalCountOfDialList: state.dialer.totalCountOfDialList,
        selectedConv: state.msgs.selectedConv,
        categoryUnSeenMsgsStatus: state.msgs.categoryUnSeenMsgsStatus,
        loadingChat: state.msgs.loadingChat,
        loadingMsg: state.msgs.loadingMsg,
        loadingSendMsg: state.msgs.loadingSendMsg,
        chatSelectedSenderName: state.msgs.chatSelectedSenderName,
        chatSelectedChannel: state.msgs.chatSelectedChannel,
        chatSelectedChannelId: state.msgs.chatSelectedChannelId,
        multiSelectCount: state.msgs.multiSelectCount,
        multiSelectCallsCount: state.dialer.multiSelectCallsCount,
        multiSelectdialListCount: state.dialer.multiSelectdialListCount,
        calls: state.dialer.calls,
        nowCall: state.dialer.nowCall,
        dialList: state.dialer.dialList,
        device: state.login.device,
        supportedMsgTypes: state.login.supportedMsgTypes,
        extId: state.login.extId,
        breakName: state.login.breakName,
        breakDurationSec: state.login.breakDurationSec,
        breakStartTime: state.login.breakStartTime,
        acdState: state.login.acdState,
        breakReasons: state.login.breakReasons,
        isDialerActive: state.login.isDialerActive,
        isPbxConnected: state.login.isPbxConnected,
        PbxConnectionStatus: state.login.PbxConnectionStatus,
        settings: state.settings,
        biUrl: state.login.biUrl,
        facebook_pageAccess: state.login.facebook_pageAccess,
        selectedMsg: state.msgs.selectedMsg,
        selectedMsgAction: state.msgs.selectedMsgAction,
        selectedMsgOpt: state.msgs.selectedMsgOpt,
        companyDetails: state.login.companyDetails,
        //Contacts
        contacts: state.contacts.contacts,
        selectedContact: state.contacts.selectedContact,
        totalCountOfContact: state.contacts.totalCountOfContact,
        enableGetCallerId: state.settings.general.enableGetCallerId,
        queryParams: state.crm.queryParams,
        dashboardSection: state.crm.dashboardSection,
        crmPath: state.crm.crmPath
    };

};

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout()),
        onLoadFetchChats: (whatChats) => dispatch(actions.fetchChat(whatChats)),
        refreshMediaToken: (mediaTokenData) => dispatch(actions.refreshMediaToken(mediaTokenData)),
        onSelectChat: (clientName, channel, startIndex, loadedMsgFromPagingCount, chatSelectedChannelId, reloadChat, msgId, startTime, finishTime) => dispatch(actions.fetchMsg(clientName, channel, settings.toloadMsgCount, startIndex, loadedMsgFromPagingCount, chatSelectedChannelId, reloadChat, msgId, startTime, finishTime)),
        onSendClicked: (clientName, channel, msg, media, opt, cb, selectedDate) => {
            // console.log(`inside ${selectedDate}`)
            dispatch(actions.sendMsg(clientName, channel, msg, media, opt, cb, selectedDate))
        },
        // updateClientAndChannel: (senderName, chatSelectedChannel) => dispatch(actions.chatSelected(senderName, chatSelectedChannel)),
        chatUnSelected: () => dispatch(actions.chatUnSelected()),
        newMsgRecived: (msg) => dispatch(actions.newMsgRecived(msg)),
        updateConversation: (conversation, chatTypeSelected, agentName, isAgentOnConvGroups) => dispatch(actions.updateConversation(conversation, chatTypeSelected, agentName, isAgentOnConvGroups)),
        newConversation: (conversation) => dispatch(actions.newConversation(conversation)),
        updateMsgRecived: (message) => dispatch(actions.updateMsgRecived(message)),
        deleteMsgRecived: (msg, chat) => dispatch(actions.deleteMsgRecived(msg, chat)),
        clearMsgs: () => dispatch(actions.clearMsgs()),
        uploadAvatar: (avatar) => dispatch(actions.uploadAvatar(avatar)),
        updateChat: (clientName, channel, opt, cb) => dispatch(actions.updateChat(clientName, channel, opt, cb)),
        fetchAgents: () => dispatch(actions.fetchAgents()),
        fetchCompanyGroups: () => dispatch(actions.fetchCompanyGroups()),
        fetchAgentTempMsg: () => dispatch(actions.fetchAgentTempMsg()),
        deleteChatRecived: (clientName, chatTypeSelected) => dispatch(actions.deleteChatRecived(clientName, chatTypeSelected)),
        deleteChat: (clientName, channel) => dispatch(actions.deleteChat(clientName, channel)),
        setCategory: (completed, isPublic) => dispatch(actions.setCategory(completed, isPublic)),
        logoutCleanChats: () => dispatch(actions.logoutMsgs()),
        makeCall: (callNum) => dispatch(actions.makeCall(callNum)),
        disconnectCall: (callId) => dispatch(actions.disconnectCall(callId)),
        answerCall: (callId) => dispatch(actions.answerCall(callId)),
        fetchCalls: (contain, numberOfCallsToFetch, startIndex) => dispatch(actions.fetchCalls(contain, numberOfCallsToFetch, startIndex)),
        CallReceivedEvent: (nowCall) => dispatch(actions.CallReceivedEvent(nowCall)),
        CallAnsweredEvent: (nowCall) => dispatch(actions.CallAnsweredEvent(nowCall)),
        CallReleasedEvent: (nowCall) => dispatch(actions.CallReleasedEvent(nowCall)),
        fetchDialList: (contain, numberOfDialListToFetch, startIndex) => dispatch(actions.fetchDialList(contain, numberOfDialListToFetch, startIndex)),
        dialListAdded: (dialItem) => dispatch(actions.dialListAdded(dialItem)),
        dialListUpdated: (dialList) => dispatch(actions.dialListUpdated(dialList)),
        dialListDeleted: (dialList) => dispatch(actions.dialListDeleted(dialList)),
        dialListAutoDeleted: (dialList) => dispatch(actions.dialListAutoDeleted(dialList)),
        dialListPostponedToOtherAgent: (dialList) => dispatch(actions.dialListPostponedToOtherAgent(dialList)),
        dialListAdd: (dialItem) => dispatch(actions.dialListAdd(dialItem)),
        dialListUpdate: (dialList) => dispatch(actions.dialListUpdate(dialList)),
        dialListDelete: (dialList) => dispatch(actions.dialListDelete(dialList)),
        callDeleted: (calls) => dispatch(actions.callDeleted(calls)),
        callDelete: (id, isMany) => dispatch(actions.callDelete(id, isMany)),
        callDetailsUpdate: (call) => dispatch(actions.callDetailsUpdate(call)),
        dialListDetailsUpdate: (dialList) => dispatch(actions.dialListDetailsUpdate(dialList)),
        initCategoryMsgUnSeenStatus: () => dispatch(actions.initCategoryMsgUnSeenStatus()),
        updateCategoryMsgUnSeenStatus: (categoryUnSeenStatusUpdateObj) => dispatch(actions.updateCategoryMsgUnSeenStatus(categoryUnSeenStatusUpdateObj)),
        companyOnlineAgents: (onlineAgents, action) => dispatch(actions.companyOnlineAgents(onlineAgents, action)),
        fetchAgentWindow: (agentWindowStateData, breakReasonsData) => dispatch(actions.fetchAgentWindow(agentWindowStateData, breakReasonsData)),
        changeAgentWindowState: (newAgentStateData) => dispatch(actions.changeAgentWindowState(newAgentStateData)),
        incBreakSec: (numToInc) => dispatch(actions.incBreakSec(numToInc)),
        changeAgentDialerState: (isDialerActiveObj) => dispatch(actions.changeAgentDialerState(isDialerActiveObj)),
        setPbxConnectedStatus: (isPbxConnected, PbxConnectionStatus) => dispatch(actions.setPbxConnectedStatus(isPbxConnected, PbxConnectionStatus)),
        fetchSettings: () => dispatch(actions.fetchSettings()),
        setSettings: (settingType, settingName, value) => dispatch(actions.setSettings(settingType, settingName, value)),//clearNowCall
        clearNowCall: () => dispatch(actions.clearNowCall()),
        updateNowCall: (fields) => dispatch(actions.updateNowCall(fields)),
        multiSelectUnselectChat: (clientName, msgType) => dispatch(actions.multiSelectUnselectChat(clientName, msgType)),
        multiSelectUnselectAllChat: (selectType) => dispatch(actions.multiSelectUnselectAllChat(selectType)),
        multiSelectUnselectCalls: (_id) => dispatch(actions.multiSelectUnselectCalls(_id)),
        multiSelectUnselectAllCalls: (selectType) => dispatch(actions.multiSelectUnselectAllCalls(selectType)),
        multiSelectUnselectDialList: (_id) => dispatch(actions.multiSelectUnselectDialList(_id)),
        multiSelectUnselectAllDialList: (selectType) => dispatch(actions.multiSelectUnselectAllDialList(selectType)),
        callConfStart: (callId, phone) => dispatch(actions.CallConfStart(callId, phone)),
        fetchChatUpdatedCrmData: (clientName, msgType) => dispatch(actions.fetchChatUpdatedCrmData(clientName, msgType)),
        fetchFacebookLogin: () => dispatch(actions.fetchFacebookLogin()),
        fetchFacebookLoginSuccess: (isFaceBookLogged) => dispatch(actions.fetchFacebookLoginSuccess(isFaceBookLogged)),
        fetchFacebookSubscribedPages: () => dispatch(actions.fetchFacebookSubscribedPages()),
        deleteManyChats: (filters) => dispatch(actions.deleteManyChats(filters)),
        selectMsg: (selectedMsg, selectedMsgAction, opt) => dispatch(actions.selectMsg(selectedMsg, selectedMsgAction, opt)),
        onGroupsActions: (data, actionName) => dispatch(actions.onGroupsActions(data, actionName)),
        fetchCompanyExtsSuccess: (companyExts) => dispatch(actions.fetchCompanyExtsSuccess(companyExts)),
        clearDialerState: () => dispatch(actions.clearDialerState()),
        clearSettingsState: () => dispatch(actions.clearSettingsState()),
        clearNotificationsState: () => dispatch(actions.clearNotificationsState()),
        fetchMyNotifications: () => dispatch(actions.fetchMyNotifications()),
        addNewNotification: (notificationObj) => dispatch(actions.addNewNotification(notificationObj)),
        deleteNotification: (notificationId) => dispatch(actions.deleteNotification(notificationId)),
        updateNotification: (notificationObj) => dispatch(actions.updateNotification(notificationObj)),
        callHoldEvent: (data) => dispatch(actions.callHoldEvent(data)),
        // Contacts
        fetchContacts: (contain, numberOfContactsToFetch, startIndex) => dispatch(actions.fetchContacts(contain, numberOfContactsToFetch, startIndex)),
        selectContactSuccess: (contactId) => dispatch(actions.selectContactSuccess(contactId)),
        insertContact: (contact) => dispatch(actions.insertContact(contact)),
        updateContact: (contact) => dispatch(actions.updateContact(contact)),
        deleteContact: (contact) => dispatch(actions.deleteContact(contact)),
        insertChatContact: (contact) => dispatch(actions.insertChatContact(contact)),
        updateChatContact: (contact) => dispatch(actions.updateChatContact(contact)),
        deleteChatContact: (contact) => dispatch(actions.deleteChatContact(contact)),
        insertCallContact: (contact) => dispatch(actions.insertCallContact(contact)),
        updateCallContact: (contact) => dispatch(actions.updateCallContact(contact)),
        deleteCallContact: (contact) => dispatch(actions.deleteCallContact(contact)),
        insertDialListContact: (contact) => dispatch(actions.insertDialListContact(contact)),
        updateDialListContact: (contact) => dispatch(actions.updateDialListContact(contact)),
        deleteDialListContact: (contact) => dispatch(actions.deleteDialListContact(contact)),
        setRouteParams: (params) => dispatch(actions.setRouteParams(params))
    };
}

export default withRouter(withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(Chat)));